// import { useState, useEffect, useMemo, useRef } from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, FormControlLabel, Checkbox, useTheme, Grid, Divider, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext';
// import EditIcon from '@mui/icons-material/Edit';
// import Dropdown from '../../../components/Dropdown';

// const ProductDetails = ({ initialData, onNext, clientData, challanIds, connectionString, mode, DebitNoteCreated, onRowsChange }) => {

//     const { user, selectedCompany, loading } = useAuth();
//     const state = clientData?.details?.['State'] || '';
//     const compState = selectedCompany?.State || '';
//     const companyId = selectedCompany?.CompId || null;
//     console.log('challanIds:', challanIds);
//     console.log(`state: ${state} || compState: ${compState}`);
//     console.log(initialData)
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: '', rate: 0, disc: 0, tax: 0, batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null });
//     const [totals, setTotals] = useState({ basic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});

//     const [gsts, setGsts] = useState([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [isInitialized, setIsInitialized] = useState(false);

//     const [tcsEnabled, setTcsEnabled] = useState(false);
//     const [tcsPercent, setTcsPercent] = useState(0);
//     const [tcsAmount, setTcsAmount] = useState(0);


//     const [isRCMApplied, setIsRCMApplied] = useState(false);
//     const [rcmConfirmOpen, setRcmConfirmOpen] = useState(false);
//     const [rcmError, setRcmError] = useState("");

//     const [rcmOpen, setRcmOpen] = useState(false);

//     const [rcmData, setRcmData] = useState({
//         taxType: '',
//         taxPercent: 0,
//         taxableAmt: 0,

//         cgst: 0,
//         sgst: 0,
//         igst: 0,

//         cgstAmt: 0,
//         sgstAmt: 0,
//         igstAmt: 0,

//         utgst: 0,
//         utgstAmt: 0,

//         cess: 0,
//         cessAmt: 0
//     });

//     console.log("RCMData", rcmData)


//     // Track if component has finished initializing
//     const hasInitializedRef = useRef(false);

//     // Notify parent when rows change â€” but ONLY after initialization is done
//     useEffect(() => {
//         if (!hasInitializedRef.current) return; // Don't fire on first empty render
//         if (onRowsChange) {
//             onRowsChange(rows);
//         }
//     }, [rows]);

//     // Reset isInitialized when coming back with data but rows are empty
//     useEffect(() => {
//         if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
//             setIsInitialized(false);
//         }
//     }, [initialData?.tableData]);

//     // For add mode â€” no initialData, so mark as initialized immediately
//     useEffect(() => {
//         if (!initialData?.tableData?.length) {
//             hasInitializedRef.current = true;
//         }
//     }, []);


//     //reset rcm error
//     useEffect(() => {
//         if (rcmError) {
//             const taxable = Number(rcmData.taxableAmt || 0);

//             if (taxable > 0) {
//                 setRcmError("");
//             }
//         }
//     }, [rcmData.taxableAmt]);

//     useEffect(() => {
//         if (rcmOpen) {
//             setRcmData(prev => ({
//                 ...prev,
//                 taxableAmt: Number(totals.basic) || 0
//             }));
//         }
//     }, [totals.basic, rcmOpen]);


//     useEffect(() => {
//         if (!tcsEnabled) {
//             setTcsAmount(0);
//             return;
//         }
//         const baseAmount =
//             Number(totals.basic || 0) +
//             Number(totals.cgst || 0) +
//             Number(totals.sgst || 0) +
//             Number(totals.igst || 0);

//         const tcs = (baseAmount * Number(tcsPercent || 0)) / 100;

//         setTcsAmount(tcs);
//     }, [tcsEnabled, tcsPercent, totals]);


//     useEffect(() => {
//         if (!initialData?.summary) return;

//         const s = initialData.summary;

//         setTcsEnabled(s.tcsApplied === 1);
//         setTcsPercent(s.tcsPercent || 0);
//         setTcsAmount(s.tcsAmount || 0);
//     }, [initialData]);


//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const API_BASE = `${connectionString}/api`;

//     const transformGSTs = data =>
//         Array.isArray(data)
//             ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode }))
//             : [];

//     const Hlp_Fn_GST = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
//             console.log(data)
//             setGsts(transformGSTs(data));
//         } catch (e) {
//             console.error('GST lookup failed', e);
//             setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
//             setGsts([]);
//         }
//     };

//     useEffect(() => {
//         Hlp_Fn_GST();
//     }, []);

//     const isProductLocked = useMemo(() => {
//         // Debit Note hard-lock
//         if (DebitNoteCreated) return true;

//         // Ref mode hard-lock
//         if (mode === 'ref') return true;

//         // Challan-linked hard-lock
//         if (!Array.isArray(initialData?.tableData)) return false;

//         return initialData.tableData.some(
//             r => r?.challanID != null || r?.challanDtsID != null
//         );
//     }, [DebitNoteCreated, mode, initialData?.tableData]);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } });
//                 setUnitOptions(unitsRes.data); // Expecting [{ UnitId: 43, unit: "NOS" }, ...]
//                 const [cRes, sRes] = await Promise.all([
//                     axios.get(`${connectionString}/api/colormaster`),
//                     axios.get(`${connectionString}/api/sizemaster`)
//                 ]);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };

//         fetchData();
//         loadAllProducts();
//     }, []);

//     const handleProductAdded = async () => {
//         // Reload units when product is added
//         try {
//             const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
//                 params: { companyId }
//             });
//             setUnitOptions(unitsRes.data);

//             // Also reload products
//             await loadAllProducts();
//         } catch (error) {
//             console.error('Error refreshing data:', error);
//         }
//     };

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data);
//         } catch (e) {
//             console.error('Error fetching products:', e);
//         }
//     };



//     const getTaxPercent = (value) => {
//         if (!value) return 0;

//         // remove % sign
//         const cleaned = value.replace('%', '').trim();

//         const parsed = parseFloat(cleaned);

//         return isNaN(parsed) ? 0 : parsed;
//     };

//     useEffect(() => {
//         if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
//             return;
//         }

//         console.log("initialData", initialData)

//         const initialRows = initialData.tableData.map((r, index) => {
//             const qty = Number(r.dispQty ?? r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const disc = Number(r.disc) || 0;
//             const taxableAmt = qty * rate * (1 - disc / 100);

//             const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);
//             let taxId = r.taxId || r.TaxId || null;
//             //  GST lookup
//             const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

//             //  final %
//             let tax = matchedGST
//                 ? getTaxPercent(matchedGST.value)
//                 : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;
//             let taxAmount = taxableAmt * (tax / 100);
//             let cgst = '0.00', sgst = '0.00', igst = '0.00';
//             let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';

//             const matchedUnit =
//                 unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) ||
//                 unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase()) ||
//                 (product ? unitOptions.find(u =>
//                     String(u.UnitId) === String(product.UnitId) ||
//                     u.unit?.toLowerCase() === String(product.Unit?.toLowerCase())
//                 ) : null);

//             const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//             console.log("GSTs:", gsts);
//             console.log("taxId:", taxId);
//             console.log("taxPercent:", tax);
//             console.log("state:", state, "compState:", compState);

//             if (product) {
//                 tax = tax;
//                 taxId = r.taxId || r.TaxId || null;        //  backend value
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = isSameState ? (tax / 2).toFixed(2) : '0.00';
//                 sgst = isSameState ? (tax / 2).toFixed(2) : '0.00';
//                 igst = !isSameState ? tax.toFixed(2) : '0.00';
//                 cgstAmt = isSameState ? (taxAmount / 2).toFixed(2) : '0.00';
//                 sgstAmt = isSameState ? (taxAmount / 2).toFixed(2) : '0.00';
//                 igstAmt = !isSameState ? taxAmount.toFixed(2) : '0.00';
//             } else {
//                 taxAmount = taxableAmt * (tax / 100);
//                 cgst = Number(r.CGST || (isSameState ? (tax / 2) : 0)).toFixed(2);
//                 sgst = Number(r.SGST || (isSameState ? (tax / 2) : 0)).toFixed(2);
//                 igst = Number(r.IGST || (!isSameState ? tax : 0)).toFixed(2);
//                 cgstAmt = Number(r.CGSTAmt || (isSameState ? (taxAmount / 2) : 0)).toFixed(2);
//                 sgstAmt = Number(r.SGSTAmt || (isSameState ? (taxAmount / 2) : 0)).toFixed(2);
//                 igstAmt = Number(r.IGSTAmt || (!isSameState ? taxAmount : 0)).toFixed(2);
//             }

//             return {
//                 ...r,
//                 productId: r.productId || r.Id || r.id || '',
//                 UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId || ''),
//                 unit: matchedUnit ? matchedUnit.unit : (product?.Unit || ''),
//                 qty,
//                 rate,
//                 disc,
//                 tax,
//                 TaxableAmt: Number(r.TaxableAmt) || taxableAmt.toFixed(2),
//                 taxAmount: Number(r.taxAmount) || taxAmount.toFixed(2),
//                 amount: Number(r.TaxableAmt) || taxableAmt.toFixed(2),
//                 CGST: cgst,
//                 SGST: sgst,
//                 IGST: igst,
//                 CGSTAmt: cgstAmt,
//                 SGSTAmt: sgstAmt,
//                 IGSTAmt: igstAmt,
//                 UTGST: String(r.UTGST || '0.00'),
//                 GSTCess: String(r.GSTCess || '0.00'),
//                 TaxId: taxId,
//                 srNo: initialData.tableData.length - index,
//                 challanDtsID: r.challanDtsID || null,
//                 challanID: r.challanID || null,
//                 soId: r.soId || null,
//                 soDtsID: r.soDtsID || null,
//                 POID: r.POID || null,
//                 PODtsID: r.PODtsID || null
//             };
//         });
//         console.log(initialRows);

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//         setIsInitialized(true);
//         hasInitializedRef.current = true; // â† for lifting rows state up 
//     }, [initialData?.tableData, unitOptions, allProducts, state, compState , isInitialized]);

//     useEffect(() => {
//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         const disc = Number(current.disc) || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent(prev => ({
//             ...prev,
//             TaxableAmt: taxableAmt.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00'
//         }));
//     }, [current.qty, current.rate, current.disc, current.tax, state, compState]);

//     useEffect(() => {
//         const n = v => Number(v || 0);
//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         let basicAmountSum = 0;
//         let discountTotal = 0;
//         let cgstTotal = 0;
//         let sgstTotal = 0;
//         let igstTotal = 0;

//         rows.forEach(r => {
//             const qty = n(r.qty);
//             const rate = n(r.rate);
//             const gross = qty * rate;
//             const taxable = n(r.amount || r.TaxableAmt);
//             const discAmtRow = n(r.DiscAmt) || Math.max(0, gross - taxable);
//             const taxPct = n(r.tax);

//             const cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
//             const sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
//             const igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));

//             basicAmountSum += taxable;
//             discountTotal += discAmtRow;
//             cgstTotal += cgstAmtRow;
//             sgstTotal += sgstAmtRow;
//             igstTotal += igstAmtRow;
//         });

//         const totalTax = cgstTotal + sgstTotal + igstTotal;

//         // âœ… SubTotal
//         const subTotal = basicAmountSum + totalTax;

//         // âœ… TCS
//         const tcs = tcsEnabled
//             ? (subTotal * Number(tcsPercent || 0)) / 100
//             : 0;

//         // âœ… FINAL BEFORE ROUND OFF
//         const finalAmount = subTotal + tcs;

//         // const roundedFinal = Math.ceil(finalAmount);
//         // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
//         const decimalPart = finalAmount - Math.floor(finalAmount);

//         const roundedFinal = decimalPart >= 0.5 ? Math.ceil(finalAmount) : Math.floor(finalAmount);

//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

//         setTotals({
//             basic: basicAmountSum.toFixed(2),
//             discount: discountTotal.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2)
//         });
//     }, [rows, state, compState, tcsEnabled, tcsPercent]);



//     const handleChange = field => e => {
//         if (field === 'UnitId') {
//             const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
//             setCurrent(prev => ({ ...prev, UnitId: e.target.value, unit: selectedUnit ? selectedUnit.unit : '' }));
//         } else {
//             setCurrent(prev => ({ ...prev, [field]: e.target.value }));
//         }
//     };

//     const handleSelect = product => {
//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && opt.UnitId === product.UnitId) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
//             return false;
//         });
//         const qty = 1;
//         const rate = Number(product.saleRate) || '';
//         const disc = Number(product.saleDiscount) || '';
//         const tax = parseFloat(product.GST) || '';
//         const taxId = product.TaxId || null;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);
//         setCurrent({
//             Id: product.Id?.toString() || '',
//             productCode: product.itemCode || '',
//             description: product.description || '',
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
//             unit: matchedUnit ? matchedUnit.unit : '',
//             qty,
//             rate,
//             disc,
//             tax,
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             remark: '',
//             TaxId: taxId,
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             UTGST: '0.00',
//             GSTCess: '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
//             TaxableAmt: taxableAmt.toFixed(2),
//             challanDtsID: null,
//             challanID: null,
//             soId: null,
//             soDtsID: null,
//             POID: null,
//             PODtsID: null
//         });
//         // setEditIndex(null);
//         setErrors({});
//     };

//     const addProduct = () => {

//         if (isProductLocked) return;

//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'tax'];

//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 messages.add('All fields are required.');
//             }
//         });

//         if (!current.qty || Number(current.qty) <= 0) {
//             errs.qty = 'Must be > 0';
//             messages.add('Qty must be greater than 0');
//         }

//         if (!current.rate || Number(current.rate) <= 0) {
//             errs.rate = 'Rate must be greater than 0';
//             messages.add('Rate must be greater than 0');
//         }

//         if (current.disc < 0) {
//             errs.disc = 'Cannot be negative';
//             messages.add('Discount cannot be negative');
//         }

//         if (current.disc > 100) {
//             errs.disc = 'Cannot be more than 100';
//             messages.add('Discount cannot be more than 100');
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }

//         const safeDisc = current.disc === '' || current.disc == null ? 0 : Number(current.disc);

//         const qty = Number(current.qty) || 0;
//         const rate = Number(current.rate) || 0;
//         // const disc = Number(current.disc) || 0;
//         const disc = safeDisc || 0;
//         const tax = Number(current.tax) || 0;
//         const taxableAmt = qty * rate * (1 - disc / 100);
//         const taxAmount = taxableAmt * (tax / 100);

//         const row = {
//             ...current,
//             productId: current.Id,
//             qty,
//             rate,
//             disc,
//             tax,
//             remark: current.remark || '',
//             TaxableAmt: taxableAmt.toFixed(2),
//             taxAmount: taxAmount.toFixed(2),
//             amount: taxableAmt.toFixed(2),
//             CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//             IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//             CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
//             IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
//             UTGST: current.UTGST,
//             GSTCess: current.GSTCess,
//             TaxId: current.TaxId,
//             srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo,
//             challanDtsID: editIndex != null ? rows[editIndex].challanDtsID : null,
//             challanID: editIndex != null ? rows[editIndex].challanID : null,
//             soId: editIndex != null ? rows[editIndex].soId : null,
//             soDtsID: editIndex != null ? rows[editIndex].soDtsID : null,
//             POID: null,
//             PODtsID: null
//         };

//         const existingRowIndex = rows.findIndex(
//             (r, i) => r.productCode === current.productCode && i !== editIndex
//         );

//         // if (existingRowIndex !== -1 && editIndex == null) {
//         //     setRows(prev =>
//         //         prev.map((r, i) => {
//         //             if (i === existingRowIndex) {
//         //                 const newQty = Number(r.qty) + qty;
//         //                 const newTaxableAmt = newQty * rate * (1 - disc / 100);
//         //                 const newTaxAmount = newTaxableAmt * (tax / 100);
//         //                 return {
//         //                     ...r,
//         //                     qty: newQty,
//         //                     rate,
//         //                     disc,
//         //                     tax,
//         //                     remark: current.remark || r.remark,
//         //                     TaxableAmt: newTaxableAmt.toFixed(2),
//         //                     taxAmount: newTaxAmount.toFixed(2),
//         //                     amount: newTaxableAmt.toFixed(2),
//         //                     CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//         //                     SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
//         //                     IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
//         //                     CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
//         //                     SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
//         //                     IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? newTaxAmount.toFixed(2) : '0.00',
//         //                     UTGST: current.UTGST,
//         //                     GSTCess: current.GSTCess,
//         //                     TaxId: current.TaxId,
//         //                     challanDtsID: r.challanDtsID,
//         //                     challanID: r.challanID,
//         //                     soId: r.soId,
//         //                     soDtsID: r.soDtsID,
//         //                     POID: r.POID || null,
//         //                     PODtsID: r.PODtsID || null
//         //                 };
//         //             }
//         //             return r;
//         //         })
//         //     );
//         // } else {
//         //     if (editIndex != null) {
//         //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
//         //     } else {
//         //         setRows(prev => [row, ...prev]);
//         //         setNextSrNo(prev => prev + 1);
//         //     }
//         // }

//         if (editIndex != null) {
//             setRows(prev => prev.map((r, i) => i === editIndex ? { ...row, srNo: rows[editIndex].srNo } : r));
//         } else {
//             setRows(prev => [row, ...prev]);
//             setNextSrNo(prev => prev + 1);
//         }

//         setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null });
//         setErrors({});
//         setEditIndex(null);
//     };


//     console.log("totals", totals)

//     const editRow = idx => {

//         if (isProductLocked) return;

//         const row = rows[idx];
//         const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) ||
//             unitOptions.find(u => String(u.UnitId) === String(row.unit)) ||
//             unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

//         setCurrent({
//             ...row,
//             Id: row.productId,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
//             unit: matchedUnit ? matchedUnit.unit : row.unit || '',
//             CGST: String(row.CGST || '0.00'),
//             SGST: String(row.SGST || '0.00'),
//             IGST: String(row.IGST || '0.00'),
//             CGSTAmt: String(row.CGSTAmt || '0.00'),
//             SGSTAmt: String(row.SGSTAmt || '0.00'),
//             IGSTAmt: String(row.IGSTAmt || '0.00'),
//             UTGST: String(row.UTGST || '0.00'),
//             GSTCess: String(row.GSTCess || '0.00'),
//             TaxableAmt: String(row.TaxableAmt || '0.00'),
//             taxAmount: String(row.taxAmount || '0.00'),
//             amount: String(row.amount || '0.00'),
//             TaxId: row.TaxId || null,
//             challanDtsID: row.challanDtsID || null,
//             challanID: row.challanID || null,
//             soId: row.soId || null,
//             soDtsID: row.soDtsID || null,
//             POID: row.POID || null,
//             PODtsID: row.PODtsID || null
//         });
//         setEditIndex(idx);
//     };

//     const deleteRow = idx => {

//         if (isProductLocked) return;

//         setRows(prev => prev.filter((_, i) => i !== idx));
//         if (idx === editIndex) {
//             setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null });
//             setEditIndex(null);
//             setErrors({});
//         }
//     };

//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         if (tcsEnabled) {
//             const percent = Number(tcsPercent);

//             if (!tcsPercent || percent <= 0) {
//                 setErrors({ global: 'TCS % is required' });
//                 return;
//             }

//             if (isNaN(percent)) {
//                 setErrors({ global: 'Invalid TCS %' });
//                 return;
//             }

//             if (percent > 100) {
//                 setErrors({ global: 'TCS % cannot exceed 100' });
//                 return;
//             }

//             // if (!/^\d+(\.\d{1,2})?$/.test(tcsPercent)) {
//             //     setErrors({ global: 'TCS % allows max 2 decimal places' });
//             //     return;
//             // }
//         }

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         const payloadRows = rows.map(r => {
//             const qty = Number(r.qty) || 0;
//             const rate = Number(r.rate) || 0;
//             const gross = qty * rate;
//             const taxable = Number(r.amount || r.TaxableAmt) || 0;
//             const discAmt = Number(r.DiscAmt) || Math.max(0, gross - taxable);
//             const taxPct = Number(r.tax) || 0;
//             const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

//             const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
//             const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (isSameState ? 0 : taxAmt);

//             return {
//                 ...r,
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 unit: r.unit,
//                 UnitId: Number(r.UnitId) || null,
//                 qty,
//                 rate,
//                 disc: Number(r.disc) || 0,
//                 tax: taxPct,
//                 batchNo: r.batchNo || '',
//                 expDate: r.expDate || null,
//                 serialNo: r.serialNo || '',
//                 remark: r.remark || '',
//                 gross: Number(gross.toFixed(2)),
//                 amount: Number(taxable.toFixed(2)),
//                 DiscAmt: Number(discAmt.toFixed(2)),
//                 taxAmount: Number(taxAmt.toFixed(2)),
//                 srNo: r.srNo,
//                 TaxId: r.TaxId || null,
//                 CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
//                 IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
//                 CGSTAmt: Number(cgstAmt.toFixed(2)),
//                 SGSTAmt: Number(sgstAmt.toFixed(2)),
//                 IGSTAmt: Number(igstAmt.toFixed(2)),
//                 UTGST: r.UTGST || '0.00',
//                 GSTCess: r.GSTCess || '0.00',
//                 challanDtsID: r.challanDtsID || null,
//                 challanID: r.challanID || null,
//                 soId: r.soId || null,
//                 soDtsID: r.soDtsID || null,
//                 POID: r.POID || null,
//                 PODtsID: r.PODtsID || null
//             };
//         });

//         const payload = {
//             tableData: payloadRows,
//             summary: {
//                 basic: Number(totals.basic),
//                 discount: Number(totals.discount),
//                 cgst: Number(totals.cgst),
//                 sgst: Number(totals.sgst),
//                 igst: Number(totals.igst),
//                 roundOff: Number(totals.roundOff),
//                 // total: Number(totals.total)
//                 tcsApplied: tcsEnabled ? 1 : 0,
//                 tcsPercent: tcsEnabled ? Number(tcsPercent) : 0,
//                 tcsAmount: tcsEnabled ? Number(tcsAmount) : 0,
//                 total: Number(totals.total),
//                 IsRCMApplied: isRCMApplied ? 1 : 0,

//                 RCMCGST: Number(rcmData.cgst || 0),
//                 RCMCGSTAmt: Number(rcmData.cgstAmt || 0),

//                 RCMSGST: Number(rcmData.sgst || 0),
//                 RCMSGSTAmt: Number(rcmData.sgstAmt || 0),

//                 RCMIGST: Number(rcmData.igst || 0),
//                 RCMIGSTAmt: Number(rcmData.igstAmt || 0),

//                 RCMGSTCess: Number(rcmData.cess || 0),
//                 RCMGSTCEssAmt: Number(rcmData.cessAmt || 0),

//                 RCMGSTEduCess: 0,
//                 RCMGSTEducessAmt: 0,

//                 RCMUTGSTAmt: 0
//             }
//         };

//         onNext(payload);
//     };

//     const formatINR = val => {
//         const num = Number(val) || 0;
//         return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     };

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt, ChallanNumber, ChallanDate } = params.row;
//                 const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//                 const matchedGST = gsts.find(g => String(g.Id) === String(params.row.TaxId));
//                 const displayTax = matchedGST
//                     ? (matchedGST.value?.toLowerCase().includes('tax free') ? '0%' : matchedGST.value)
//                     : (!params.row.tax || Number(params.row.tax) === 0
//                         ? '0%'
//                         : `${params.row.tax}%`);
//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             <Typography variant="body2" fontWeight="bold" component="div"
//                                 sx={{ cursor: isProductLocked ? 'not-allowed' : 'pointer', color: isProductLocked ? '#999' : '#1877F2', textDecoration: isProductLocked ? 'none' : 'underline', fontSize: '0.85rem' }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     if (mode !== 'ref' || !isProductLocked) {
//                                         editRow(params.row.index);
//                                     }
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography>

//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block">
//                             Unit: {unit || 'N/A'} | GST: {displayTax}
//                         </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `SGST: ₹${formatINR(SGSTAmt)} + CGST: ₹${formatINR(CGSTAmt)}` : `IGST: ₹${formatINR(IGSTAmt)}`}
//                         </Typography>
//                         {(batchNo || expDate || serialNo) && (
//                             <Typography variant="caption" display="block">
//                                 {batchNo && `Batch: ${batchNo}`}
//                                 {expDate && ` | Exp: ${expDate}`}
//                             </Typography>
//                         )}
//                         {remark && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
//                         {(ChallanNumber || ChallanDate) && (
//                             <Typography variant="caption" display="block" color='blue'>
//                                 {ChallanNumber && `ChallanNo: ${ChallanNumber}`}
//                                 {ChallanDate && ` | Date: ${ChallanDate}`}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             }
//         },
//         { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
//         { field: 'amount', headerName: 'Amount (₹)', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => (
//                 <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error" disabled={mode === 'ref' || isProductLocked}>
//                     <DeleteIcon fontSize="small" />
//                 </IconButton>
//             )
//         }
//     ];

//     useEffect(() => {
//         if (!initialData?.summary) return;

//         const s = initialData.summary;

//         const isApplied = s.IsRCMApplied === 1;

//         setIsRCMApplied(isApplied);

//         if (isApplied) {
//             setRcmData({
//                 taxType: '', // not storing this in DB
//                 taxPercent: 0, // optional

//                 taxableAmt: Number(totals.basic) || 0,

//                 cgst: Number(s.RCMCGST || 0),
//                 sgst: Number(s.RCMSGST || 0),
//                 igst: Number(s.RCMIGST || 0),

//                 cgstAmt: Number(s.RCMCGSTAmt || 0),
//                 sgstAmt: Number(s.RCMSGSTAmt || 0),
//                 igstAmt: Number(s.RCMIGSTAmt || 0),

//                 utgst: 0,
//                 utgstAmt: Number(s.RCMUTGSTAmt || 0),

//                 cess: Number(s.RCMGSTCess || 0),
//                 cessAmt: Number(s.RCMGSTCEssAmt || 0)
//             });
//         }
//     }, [initialData, totals.basic]);

//     // const hasClientGST = Boolean(clientData?.selectedGSTNum?.trim());
//     const hasClientGST = Boolean(clientData?.gstValue?.trim());

//     const hasGSTAmount =
//         Number(totals.cgst) > 0 ||
//         Number(totals.sgst) > 0 ||
//         Number(totals.igst) > 0;

//     const isRCMCalculated =
//         Number(rcmData.cgstAmt) > 0 ||
//         Number(rcmData.sgstAmt) > 0 ||
//         Number(rcmData.igstAmt) > 0;

//     return (
//         <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
//                     <Box>
//                         <DropdownProductCode id="productCode" label="Product Code" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} searchBy="code" onProductMasterClose={handleProductAdded} />
//                         {!!errors.productCode && (<Typography color="error" variant="caption"> {errors.productCode} </Typography>)}
//                     </Box>
//                     {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 40 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
//                     <DropdownProductCode id="description" label="Description" options={allProducts} value={current.description} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} searchBy="description" onProductMasterClose={handleProductAdded} />
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Unit" select required fullWidth size='small' value={String(current.UnitId)} onChange={handleChange('UnitId')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} >
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u.UnitId} value={u.UnitId}>
//                                     {u.unit}
//                                 </option>
//                             ))}
//                         </TextField>
//                         {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
//                         <Dropdown
//                             id="gst"
//                             label="GST"
//                             valueKey="Id"
//                             labelKey="value"
//                             value={current.TaxId ? String(current.TaxId) : ""}
//                             options={gsts}
//                             required
//                             onChange={(opt) => {
//                                 if (!opt) {
//                                     setCurrent(prev => ({ ...prev, tax: 0, TaxId: null }));
//                                 } else {
//                                     const gstValue = parseFloat(opt.value) || 0;
//                                     setCurrent(prev => ({ ...prev, tax: gstValue, TaxId: opt.Id }));
//                                 }
//                             }}
//                         />
//                     </Box>
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Qty" required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Rate" required size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Disc%" size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     <Box>
//                         <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} />
//                     </Box>
//                     <Box display="flex" justifyContent="center">
//                         <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={mode === 'ref' || DebitNoteCreated || isProductLocked} >
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>
//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
//                     {isMobile ? (
//                         <Box>
//                             {rows.map((row, i) => (
//                                 <Box key={i} sx={{ border: "1px solid #cbd5e1", borderRadius: 2, p: 1.5, mb: 1.5, cursor: isProductLocked ? 'not-allowed' : 'pointer', color: isProductLocked && "text.disabled", }} >
//                                     <Typography sx={{ fontWeight: 600 }}>
//                                         {row.productCode} â€”{" "}
//                                         <Box
//                                             component="span"
//                                             sx={{
//                                                 fontStyle: "italic",
//                                                 fontWeight: "normal",
//                                                 display: "inline",
//                                                 wordBreak: "break-word",
//                                                 whiteSpace: "normal"
//                                             }}
//                                         >
//                                             {row.description}
//                                         </Box>
//                                     </Typography>

//                                     {(row.ChallanNumber || row.ChallanDate) && (
//                                         <Typography variant="caption" display="block" color='blue'>
//                                             {row.ChallanNumber && `ChallanNo: ${row.ChallanNumber}`}
//                                             {row.ChallanDate && ` | Date: ${row.ChallanDate}`}
//                                         </Typography>
//                                     )}

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Qty:</Typography>
//                                         <Typography>{row.qty}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Rate:</Typography>
//                                         <Typography>₹{row.rate}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Disc:</Typography>
//                                         <Typography>{row.disc}%</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Amount:</Typography>
//                                         <Typography>₹{row.amount}</Typography>
//                                     </Grid>

//                                     {/* TAX INFO */}
//                                     <Grid container justifyContent="space-between">
//                                         <Typography>GST:</Typography>
//                                         <Typography>{row.tax}%</Typography>
//                                     </Grid>

//                                     {state?.toLowerCase() === compState?.toLowerCase() ? (
//                                         <>
//                                             <Grid container justifyContent="space-between">
//                                                 <Typography>CGST:</Typography>
//                                                 <Typography>₹{formatINR(row.CGSTAmt)}</Typography>
//                                             </Grid>
//                                             <Grid container justifyContent="space-between">
//                                                 <Typography>SGST:</Typography>
//                                                 <Typography>₹{formatINR(row.SGSTAmt)}</Typography>
//                                             </Grid>
//                                         </>
//                                     ) : (
//                                         <Grid container justifyContent="space-between">
//                                             <Typography>IGST:</Typography>
//                                             <Typography>₹{formatINR(row.IGSTAmt)}</Typography>
//                                         </Grid>
//                                     )}

//                                     {/* Remark */}
//                                     {row.remark && row.remark.trim() !== '' && (
//                                         <Typography
//                                             variant="caption"
//                                             color="text.secondary"
//                                             sx={{
//                                                 mt: 1,
//                                                 display: 'block',
//                                                 wordBreak: 'break-word',
//                                                 overflowWrap: 'anywhere',
//                                                 whiteSpace: 'normal'
//                                             }}
//                                         >
//                                             Remark: {row.remark}
//                                         </Typography>
//                                     )}

//                                     {/* DELETE / EDIT BUTTONS IF NEEDED */}
//                                     <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
//                                         <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'ref' || DebitNoteCreated || isProductLocked}>
//                                             <EditIcon fontSize="small" />
//                                         </IconButton>
//                                         <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'ref' || DebitNoteCreated || isProductLocked}>
//                                             <DeleteIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                     ) : (
//                         <DataGrid
//                             rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                             columns={columns}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             disableRowSelectionOnClick
//                             hideFooter
//                             sx={{
//                                 mt: 5,
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 1,
//                                 '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                                 '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
//                             }}
//                         />
//                     )}
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state?.toLowerCase() === compState?.toLowerCase() ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             totals.igst > 0 && (
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>IGST</Typography>
//                                     <Typography>₹{formatINR(totals.igst)}</Typography>
//                                 </Grid>
//                             )
//                         )}
//                         {/* TCS ROW */}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>

//                             {/* LEFT SIDE */}
//                             <Grid item display="flex" alignItems="center" gap={2}>
//                                 <FormControlLabel
//                                     control={
//                                         <Checkbox
//                                             checked={tcsEnabled}
//                                             onChange={(e) => setTcsEnabled(e.target.checked)}
//                                         />
//                                     }
//                                     label="TCS"
//                                 />

//                                 {tcsEnabled && (
//                                     <>
//                                         <TextField
//                                             label="TCS %"
//                                             size="small"
//                                             type="number"
//                                             value={tcsPercent}
//                                             onChange={(e) => {
//                                                 let val = e.target.value;

//                                                 // Allow empty (for backspace)
//                                                 if (val === '') {
//                                                     setTcsPercent('');
//                                                     return;
//                                                 }

//                                                 // Regex: numbers with max 5 decimal places
//                                                 const regex = /^\d*\.?\d{0,5}$/;

//                                                 if (!regex.test(val)) {
//                                                     return; // âŒ ignore invalid input
//                                                 }

//                                                 let num = Number(val);

//                                                 if (num < 0) num = 0;
//                                                 if (num > 100) num = 100;

//                                                 setTcsPercent(val); // keep as string for precision
//                                             }}
//                                             inputProps={{ min: 0, max: 100 }}
//                                             sx={{ width: 90 }}
//                                         />

//                                         <TextField
//                                             label="Amt"
//                                             size="small"
//                                             value={formatINR(tcsAmount)}
//                                             disabled
//                                             sx={{ width: 120 }}
//                                         />
//                                     </>
//                                 )}
//                             </Grid>

//                             {/* RIGHT SIDE (LIKE OTHER ROWS) */}
//                             <Grid item>
//                                 <Typography>
//                                     ₹{formatINR(tcsAmount)}
//                                 </Typography>
//                             </Grid>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                             {/* <Typography fontWeight={600}>₹{formatINR(finalTotal)}</Typography> */}
//                         </Grid>

//                         <Box mt={2} display="flex" justifyContent="space-between" alignItems="center" >

//                             {/* LEFT SIDE â†’ RCM */}
//                             <Box display="flex" alignItems="center" gap={2}>

//                                 <FormControlLabel
//                                     control={
//                                         <Checkbox
//                                             checked={isRCMApplied}
//                                             onChange={(e) => {
//                                                 const checked = e.target.checked;

//                                                 if (!checked) {
//                                                     //  uncheck â†’ reset
//                                                     setIsRCMApplied(false);
//                                                     setRcmData({
//                                                         taxType: '',
//                                                         taxPercent: 0,
//                                                         taxableAmt: 0,
//                                                         cgst: 0,
//                                                         sgst: 0,
//                                                         igst: 0,
//                                                         cgstAmt: 0,
//                                                         sgstAmt: 0,
//                                                         igstAmt: 0,
//                                                         utgst: 0,
//                                                         utgstAmt: 0,
//                                                         cess: 0,
//                                                         cessAmt: 0
//                                                     });
//                                                     return;
//                                                 }

//                                                 // âœ… CHECK â†’ same logic as before
//                                                 const shouldShowWarning = hasClientGST || hasGSTAmount;

//                                                 if (shouldShowWarning) {
//                                                     setRcmConfirmOpen(true);
//                                                     // â— Keep checkbox unchecked
//                                                     setIsRCMApplied(false);
//                                                     return;
//                                                 }

//                                                 // âœ… No GST â†’ open modal
//                                                 setRcmOpen(true);
//                                             }}
//                                         />
//                                     }
//                                     label="Apply RCM"
//                                 />

//                                 {/*  RCM AMOUNT INLINE */}
//                                 {isRCMApplied && (
//                                     <Box display="flex" gap={2}>

//                                         {Number(rcmData.cgstAmt) > 0 && (
//                                             <Typography variant="body2">
//                                                 CGST: ₹{formatINR(rcmData.cgstAmt)}
//                                             </Typography>
//                                         )}

//                                         {Number(rcmData.sgstAmt) > 0 && (
//                                             <Typography variant="body2">
//                                                 SGST: ₹{formatINR(rcmData.sgstAmt)}
//                                             </Typography>
//                                         )}

//                                         {Number(rcmData.igstAmt) > 0 && (
//                                             <Typography variant="body2">
//                                                 IGST: ₹{formatINR(rcmData.igstAmt)}
//                                             </Typography>
//                                         )}

//                                     </Box>
//                                 )}
//                             </Box>

//                             {/* RIGHT SIDE â†’ NEXT BUTTON */}
//                             <Button
//                                 variant="contained"
//                                 onClick={handleNext}
//                                 disabled={editIndex !== null}
//                             >
//                                 Next
//                             </Button>

//                         </Box>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && (
//                 <Typography color="error" sx={{ mt: 2 }}>
//                     {errors.global}
//                 </Typography>
//             )}
//             {/* <Box mt={1} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={editIndex !== null}>
//                     Next
//                 </Button>
//             </Box> */}


//             <Dialog open={rcmOpen} onClose={() => setRcmOpen(false)} maxWidth="sm" fullWidth>
//                 <DialogTitle>RCM Calculator</DialogTitle>

//                 <DialogContent>
//                     <Box display="flex" flexDirection="column" gap={2} mt={1}>

//                         <TextField
//                             label="Taxable Amount"
//                             value={rcmData.taxableAmt}
//                             fullWidth
//                             size="small"
//                             disabled
//                         />

//                         <Dropdown
//                             id="rcm-gst"
//                             label="Tax Type"
//                             valueKey="Id"
//                             labelKey="value"
//                             value={rcmData.taxType ? String(rcmData.taxType) : ""}
//                             options={gsts}
//                             onChange={(opt) => {
//                                 setRcmError("");
//                                 if (!opt) {
//                                     setRcmData(prev => ({
//                                         ...prev,
//                                         taxType: '',
//                                         taxPercent: 0
//                                     }));
//                                 } else {
//                                     const gstPercent = Number(
//                                         String(opt.value).replace(/[^\d.]/g, '')
//                                     ) || 0;

//                                     setRcmData(prev => ({
//                                         ...prev,
//                                         taxType: opt.Id,       // store TaxId
//                                         taxPercent: gstPercent // store %
//                                     }));
//                                 }
//                             }}
//                         />

//                         {rcmError && (
//                             <Typography color="error" fontSize="0.8rem">
//                                 {rcmError}
//                             </Typography>
//                         )}
//                         <Box display={"flex"} justifyContent={"center"}>

//                             <Button
//                                 variant="contained"
//                                 onClick={() => {
//                                     const taxable = Number(rcmData.taxableAmt || 0);
//                                     const rate = Number(rcmData.taxPercent || 0);

//                                     // âŒ Validation
//                                     if (!taxable || taxable <= 0) {
//                                         setRcmError("Taxable amount must be greater than 0.");
//                                         return;
//                                     }

//                                     if (!rate) {
//                                         setRcmError("Please select a tax type.");
//                                         return;
//                                     }

//                                     // âœ… Clear error if valid
//                                     setRcmError("");

//                                     //  Your existing calculation logic
//                                     const taxAmount = (taxable * rate) / 100;

//                                     if (state?.toLowerCase() === compState?.toLowerCase()) {
//                                         const halfTax = rate / 2;
//                                         const halfAmt = taxAmount / 2;

//                                         setRcmData(prev => ({
//                                             ...prev,
//                                             cgst: halfTax.toFixed(2),
//                                             sgst: halfTax.toFixed(2),
//                                             igst: 0,

//                                             cgstAmt: halfAmt.toFixed(2),
//                                             sgstAmt: halfAmt.toFixed(2),
//                                             igstAmt: 0
//                                         }));
//                                     } else {
//                                         setRcmData(prev => ({
//                                             ...prev,
//                                             igst: rate.toFixed(2),
//                                             cgst: 0,
//                                             sgst: 0,

//                                             igstAmt: taxAmount.toFixed(2),
//                                             cgstAmt: 0,
//                                             sgstAmt: 0
//                                         }));
//                                     }
//                                 }}
//                             >
//                                 Apply
//                             </Button>

//                         </Box>
//                         <Box display="flex" gap={2}>
//                             <TextField label="CGST %" value={rcmData.cgst} size="small" disabled fullWidth />
//                             <TextField label="CGST Amt" value={rcmData.cgstAmt} size="small" disabled fullWidth />
//                         </Box>

//                         <Box display="flex" gap={2}>
//                             <TextField label="SGST %" value={rcmData.sgst} size="small" disabled fullWidth />
//                             <TextField label="SGST Amt" value={rcmData.sgstAmt} size="small" disabled fullWidth />
//                         </Box>

//                         <Box display="flex" gap={2}>
//                             <TextField label="IGST %" value={rcmData.igst} size="small" disabled fullWidth />
//                             <TextField label="IGST Amt" value={rcmData.igstAmt} size="small" disabled fullWidth />
//                         </Box>

//                         <Box display="flex" gap={2}>
//                             <TextField label="UTGST %" value={rcmData.utgst} size="small" disabled fullWidth />
//                             <TextField label="UTGST Amt" value={rcmData.utgstAmt} size="small" disabled fullWidth />
//                         </Box>

//                         <Box display="flex" gap={2}>
//                             <TextField label="CESS %" value={rcmData.cess} size="small" disabled fullWidth />
//                             <TextField label="CESS Amt" value={rcmData.cessAmt} size="small" disabled fullWidth />
//                         </Box>

//                     </Box>
//                 </DialogContent>

//                 <DialogActions>
//                     <Button onClick={() => setRcmOpen(false)}>Cancel</Button>
//                     <Button
//                         variant="contained"
//                         disabled={!isRCMCalculated}
//                         onClick={() => {
//                             setIsRCMApplied(true);
//                             setRcmOpen(false);

//                             setTimeout(() => {
//                                 setSnackbar({
//                                     open: true,
//                                     message: "RCM applied successfully.",
//                                     severity: "success"
//                                 });
//                             }, 200);
//                         }}
//                     >
//                         OK
//                     </Button>
//                 </DialogActions>
//             </Dialog>


//             <Dialog
//                 open={rcmConfirmOpen}
//                 onClose={() => setRcmConfirmOpen(false)}
//                 maxWidth="xs"
//                 fullWidth
//             >
//                 <DialogTitle sx={{ pb: 1 }}>
//                     <Typography fontWeight={600} color="error.main">
//                         RCM Not Allowed
//                     </Typography>
//                 </DialogTitle>

//                 <DialogContent>
//                     <Box display="flex" flexDirection="column" gap={2}>

//                         {/*  Main Message */}
//                         <Typography variant="body2" color="text.secondary">
//                             GST is already present for this transaction. Applying RCM is not allowed.
//                         </Typography>

//                         {/*  Info Box */}
//                         <Box
//                             sx={{
//                                 p: 2,
//                                 borderRadius: 2,
//                                 backgroundColor: '#f8f9fb',
//                                 border: '1px solid #e0e0e0'
//                             }}
//                         >

//                             {/* CLIENT INFO */}
//                             {hasClientGST && (
//                                 <Box mb={hasGSTAmount ? 1 : 0}>
//                                     <Typography variant="caption" color="text.secondary">
//                                         CLIENT DETAILS
//                                     </Typography>

//                                     <Typography variant="body2">
//                                         {clientData.companyName || '-'}
//                                     </Typography>

//                                     <Typography variant="body2" color="text.secondary">
//                                         GST: {clientData.gstValue || 'Not Available'}
//                                     </Typography>
//                                 </Box>
//                             )}

//                             {/* GST AMOUNTS */}
//                             {hasGSTAmount && (
//                                 <Box>
//                                     <Typography variant="caption" color="text.secondary">
//                                         APPLIED TAX DETAILS
//                                     </Typography>

//                                     {Number(totals.cgst) > 0 && (
//                                         <Typography variant="body2">
//                                             CGST: ₹{formatINR(totals.cgst)}
//                                         </Typography>
//                                     )}

//                                     {Number(totals.sgst) > 0 && (
//                                         <Typography variant="body2">
//                                             SGST: ₹{formatINR(totals.sgst)}
//                                         </Typography>
//                                     )}

//                                     {Number(totals.igst) > 0 && (
//                                         <Typography variant="body2">
//                                             IGST: ₹{formatINR(totals.igst)}
//                                         </Typography>
//                                     )}
//                                 </Box>
//                             )}
//                         </Box>
//                     </Box>
//                 </DialogContent>

//                 <DialogActions sx={{ px: 3, pb: 2 }}>
//                     <Button
//                         variant="contained"
//                         color="error"
//                         onClick={() => {
//                             setRcmConfirmOpen(false);
//                             setIsRCMApplied(false);
//                             setRcmError("");

//                             setRcmData({
//                                 taxType: '',
//                                 taxPercent: 0,
//                                 taxableAmt: 0,
//                                 cgst: 0,
//                                 sgst: 0,
//                                 igst: 0,
//                                 cgstAmt: 0,
//                                 sgstAmt: 0,
//                                 igstAmt: 0,
//                                 utgst: 0,
//                                 utgstAmt: 0,
//                                 cess: 0,
//                                 cessAmt: 0
//                             });
//                         }}
//                     >
//                         Close
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={1000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// };

// export default ProductDetails;




import { colors as themeColors } from '../../../utils/theme';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DropdownProductCode from './DropdownProductCode';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaCartShopping } from "react-icons/fa6";
// import SerialBatchModal from './SerialBatchModal';
import Dropdown from '../../../components/Dropdown';
import { Snackbar, Alert } from '@mui/material';
import { useVisibleColumns } from '../../../hooks/useVisibleColumns';
import { COL } from '../../../constants/columnConstants';
import { useUserDefine } from '../../../context/UserDefineContext';
import { useStockValidation } from '../../../hooks/useStockValidation';
import { colors } from "../../../utils/theme";

// "Apply in Amt = Pkg*Qty*Rate?" — when this configure is enabled, a Pkg field
// containing anything that isn't a clean number (letters/special characters) must
// make the Pkg*Qty*Rate calculation come out as 0, instead of calculateAmount()'s
// own internal `Number(pkg) || 1` silently promoting invalid input back to 1.
// Blank/null/undefined Pkg is untouched — it still defaults to 1 (existing
// behavior for a fresh row before the user has typed a Pkg value).
const isGarbagePkg = (rawPkg) =>
    rawPkg !== '' && rawPkg !== null && rawPkg !== undefined && Number.isNaN(Number(rawPkg));

const getAmountCalcSafe = (qty, rate, rawPkg, disc, isApplyPkgInAmtEnabled, calculateAmount) => {
    if (isApplyPkgInAmtEnabled && isGarbagePkg(rawPkg)) {
        return { gross: 0, taxable: 0 };
    }
    return calculateAmount(qty, rate, rawPkg, disc);
};

const ProductDetails = ({ initialData, onNext, clientData, challanIds, connectionString, mode, DebitNoteCreated, invoiceDate, onRowsChange, L_No }) => {

    const { user, selectedCompany, loading, configureData } = useAuth();
    const { isColVisible, getColLabel, getColRow } = useVisibleColumns('PURC');
    // RupessToBeAsk=1 ("Rupees") -> only the Oth field itself is shown (as before).
    // RupessToBeAsk=0 ("Percentage") -> also show its disabled, read-only Amount field.
    const isOthRupeesMode = (colNo) => Boolean(getColRow(colNo)?.RupessToBeAsk);
    // Oth1→Oth7: each one's amount is applied in order on top of the running
    // TaxableAmt (qty*rate*(1-disc/100) as the starting base) — Percentage mode
    // takes its % against the running total so far (not the original base),
    // Rupees mode adds/subtracts a flat value; AddLess=1 means subtract, 0 means add.
    const OTH_FIELDS = [
        { field: 'oth1', col: COL.OTH1 },
        { field: 'oth2', col: COL.OTH2 },
        { field: 'oth3', col: COL.OTH3 },
        { field: 'oth4', col: COL.OTH4 },
        { field: 'oth5', col: COL.OTH5 },
        { field: 'oth6', col: COL.OTH6 },
        { field: 'oth7', col: COL.OTH7 },
    ];
    // Applies Oth1→Oth7 in order on top of `base`, returning both the final
    // taxable amount AND each Oth's own computed rupee contribution (so the
    // disabled "Oth N Amount" field — oth{N}Amt — has something to show in
    // Percentage mode). Used both for the live preview while editing and for
    // the actual Add/Update Product commit, so the two never disagree.
    const applyOthCharges = (base, rowState) => {
        let running = base;
        const amounts = {};
        OTH_FIELDS.forEach(({ field, col }) => {
            const amtField = `${field}Amt`;
            const row = getColRow(col);
            const isRupees = Boolean(row?.RupessToBeAsk);
            const isMinus = Boolean(row?.AddLess);
            // Rupees mode: OthN itself is left 0 in the DB (decimal(5,2), not
            // meant to hold a rupee amount) — the real typed value lives in
            // OthNAmt, so that's the source of truth to read back here too.
            const raw = isRupees ? rowState[amtField] : rowState[field];
            const val = Number(raw);
            if (!raw || Number.isNaN(val) || val === 0) {
                amounts[amtField] = null;
                return;
            }
            const contribution = isRupees ? val : (running * val) / 100;
            // Rupees mode: amtField IS the field the user is actively typing into
            // (othDisplayField routes it there) — reformatting it with toFixed(2)
            // on every keystroke changes the string under the cursor and resets
            // cursor position to the end. Keep the raw typed text as-is; it's only
            // ever Number()'d downstream, so the unformatted string is fine.
            // Percentage mode's amtField is a separate disabled/read-only display,
            // so reformatting it is safe and keeps it looking like a computed amount.
            amounts[amtField] = isRupees ? raw : contribution.toFixed(2);
            running = isMinus ? running - contribution : running + contribution;
        });
        return { taxableAmt: running, amounts };
    };
    // Recomputes base=qty*rate*(1-disc/100) + Oth1→Oth7 from whatever's currently
    // in `updated`, returning the fields to merge back into state. Shared by both
    // the Oth field handler and the Qty/Rate/Disc handlers so TaxableAmt/amount
    // stay Oth-adjusted live, no matter which of the four fields just changed.
    const recomputeTaxable = (updated) => {
        const qty = Number(updated.qty) || 0;
        const rate = Number(updated.rate) || 0;
        const disc = Number(updated.disc) || 0;
        // Use the same Pkg-aware calc as Add Product/handleNext (getAmountCalcSafe)
        // instead of raw qty*rate*(1-disc/100) — otherwise live Oth1-7 typing
        // ignores Pkg*Qty*Rate when "Apply in Amt = Pkg*Qty*Rate?" is enabled.
        const base = getAmountCalcSafe(qty, rate, updated.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        const { taxableAmt, amounts } = applyOthCharges(base, updated);
        return { ...amounts, TaxableAmt: taxableAmt.toFixed(2), amount: taxableAmt.toFixed(2) };
    };
    // Rupees mode: OthN itself stays 0 in the DB, so the field the user
    // actually types/sees is OthNAmt directly. Percentage mode: the user
    // types the % into OthN, and OthNAmt is the computed, read-only result.
    const othDisplayField = (field, col) => isOthRupeesMode(col) ? `${field}Amt` : field;
    const handleOthChange = (field, col) => (e) => {
        let raw = e.target.value;
        // Numbers only (digits with at most one decimal point) — no letters/special chars
        if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) return;
        if (!isOthRupeesMode(col) && raw !== '') {
            // Percentage mode: clamp to [0, 100]
            const num = Number(raw);
            if (num > 100) raw = '100';
            if (num < 0) raw = '0';
        }
        const targetKey = othDisplayField(field, col);
        setCurrent(prev => {
            const updated = { ...prev, [targetKey]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };
    // Qty/Rate/Disc changing also shifts the base amount Oth1-7 are computed
    // from — reapply them live here too, instead of only on Add/Update Product.
    const handleBaseFieldChange = (field) => (e) => {
        const raw = e.target.value;
        setCurrent(prev => {
            const updated = { ...prev, [field]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };
    const { getSelectedCharges, getChargeItemId, userDefineData } = useUserDefine();
    const { validateStock, isLastPurchaseRateEnabled, getLastPurchaseRate, isShowOnlineStockPurchaseEnabled, getOnlineStockDetails, isApplyMRPInPurchaseEnabled, calculatePurchaseRateFromMRP, isApplyPkgInAmtEnabled, calculateAmount, isApplyRateOnConversionEnabled, calculateConversion, isShowItemListPartywiseInPurchaseEnabled, isApplyPartywisePriceListDiscInPurchaseEnabled, getPriceListRatePurchase, getClientDiscountPurchase, getGroupWiseDiscPurchase, getPartywiseRatePurchase, isApplyTDSEnabled , isDiscSchemeEnabled, getClientDiscScheme } = useStockValidation(connectionString, selectedCompany?.CompId, selectedCompany?.AppRegID);
    console.log('💾 Purchase_Invoice: isLastPurchaseRateEnabled:', isLastPurchaseRateEnabled);
    console.log('📊 Purchase_Invoice: isShowOnlineStockPurchaseEnabled:', isShowOnlineStockPurchaseEnabled);
    // getSelectedCharges() returns a brand-new array on every call (Array.filter),
    // even when userDefineData hasn't changed — used as a useEffect dependency
    // further down, an unstable reference there re-fires those effects (and their
    // setState calls) on every render, causing an infinite render loop. Memoize
    // on userDefineData (the actual stable source data) so the array reference
    // only changes when the underlying charges data actually changes.
    const additionalCharges = useMemo(() => getSelectedCharges('PURC'), [userDefineData]);
    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);
    const [chargesCollapsibleOpen, setChargesCollapsibleOpen] = useState(true);
    const [chargeInputs, setChargeInputs] = useState({});
    const [onlineStockDetails, setOnlineStockDetails] = useState({
        closingStock: null,
        maxLevel: null,
        minLevel: null,
    });
    // Additional Charges contribution applied to the summary panel — populated
    // only when the user clicks Save in the Charges popup (see handleSaveCharges).
    const [chargesSummary, setChargesSummary] = useState({ total: 0, cgst: 0, sgst: 0, igst: 0 });

    // Restore chargeInputs and chargesSummary from initialData if provided (when loading an existing quotation)
    useEffect(() => {
        // API chargeInputs are already keyed by TransType (200, 201, 202, 203, 204)
        // which matches charge.TransType in additionalCharges, so no mapping needed
        if (initialData?.chargeInputs && Object.keys(initialData.chargeInputs).length > 0) {
            console.log('[ChargeInputs Debug] API chargeInputs keys:', Object.keys(initialData.chargeInputs));
            if (additionalCharges && additionalCharges.length > 0) {
                console.log('[ChargeInputs Debug] additionalCharges:', additionalCharges.map(c => ({ TransType: c.TransType, SrNo: c.SrNo, name: c.ChargeName })));
            }
            setChargeInputs(initialData.chargeInputs);
        }

        // Restore chargesSummary from charge rows in tableData (has actual calculated tax amounts)
        // This is more reliable since the API calculates taxes based on actual requirements
        if (initialData?.tableData) {
            const chargesTaxData = { total: 0, cgst: 0, sgst: 0, igst: 0 };

            initialData.tableData.forEach(row => {
                const transType = row.TransType != null ? parseInt(row.TransType) : 100;
                const isCharge = transType >= 200 && transType <= 204;
                if (isCharge) {
                    // Use the amount from the charge row
                    chargesTaxData.total += Number(row.amount || 0);
                    // Add the tax amounts from the charge row (already calculated by backend)
                    chargesTaxData.cgst += Number(row.CGSTAmt || 0);
                    chargesTaxData.sgst += Number(row.SGSTAmt || 0);
                    chargesTaxData.igst += Number(row.IGSTAmt || 0);
                }
            });

            console.log('[ChargesSummary Debug] Calculated from tableData:', chargesTaxData);

            if (chargesTaxData.total > 0 || chargesTaxData.cgst > 0 || chargesTaxData.sgst > 0 || chargesTaxData.igst > 0) {
                setChargesSummary(chargesTaxData);
            }
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setChargesSummary call) on every parent re-render, not just when
        // the actual saved charge data changes.
    }, [initialData?.chargeInputs, initialData?.tableData]);

    // Populate each charge slot's editable state (Amount, and Tax when TaxEnabled)
    // fresh every time the popup opens — default Tax is whatever was saved for
    // that slot in UserDefineColumns (charge.TaxId). Preserve amount if already restored from initialData.
    useEffect(() => {
        if (!chargesDialogOpen) return;
        setChargeInputs(prev => {
            const next = { ...prev };
            additionalCharges.forEach(charge => {
                const key = charge.TransType;
                if (!next[key]) {
                    // Only set empty amount if not already populated (e.g., from initialData restore)
                    next[key] = {
                        amount: '',
                        taxId: charge.TaxId ?? null,
                    };
                } else {
                    // Preserve existing amount, but update taxId to the configured one if not already set
                    if (next[key].taxId === null && charge.TaxId !== null) {
                        next[key].taxId = charge.TaxId;
                    }
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargesDialogOpen, additionalCharges]);

    const updateChargeInput = (key, patch) => {
        setChargeInputs(prev => ({
            ...prev,
            [key]: { ...prev[key], ...patch },
        }));
    };
    const state = clientData?.details?.['State'] || '';
    const compState = selectedCompany?.State || '';
    const companyId = selectedCompany?.CompId || null;
    console.log('challanIds:', challanIds);
    console.log(`state: ${state} || compState: ${compState}`);
    console.log(initialData)
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [rows, setRows] = useState([]);
    const [nextSrNo, setNextSrNo] = useState(1);
    const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: '', batchNo: '', expDate: '', serialNo: '', amount: '', taxAmount: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', GSTOth: '0.00', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth5: '', oth6: '', oth7: '', TransType: 100,
        // "Enable Convesrion effect in Transaction?" fields — defaultUnitId/convUnitId/productConvQty
        // are captured once at product-select time from productmaster (UnitId/
        // ConvUnit/ConvQty) and never change while this row's product stays the
        // same. baseRate preserves the rate as it stood before any conversion
        // division, so switching Unit back to defaultUnitId can restore it exactly.
        // ConversionQty/ConversionRate are only non-null while a conversion is
        // actively applied to this row (see purcinvoicedetails.ConversionQty/
        // ConversionRate columns) — both map 1:1 onto payload/stock fields.
        defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null });
    const [totals, setTotals] = useState({ basic: 0, grossBasic: 0, discount: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, total: 0 });
    const [errors, setErrors] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [colorMap, setColorMap] = useState({});
    const [sizeMap, setSizeMap] = useState({});
    const [gsts, setGsts] = useState([]);

    // Stock validation warning dialog state
    const [stockWarningOpen, setStockWarningOpen] = useState(false);
    const [stockWarningData, setStockWarningData] = useState(null);
    const [stockConfirmResolve, setStockConfirmResolve] = useState(null);

    // "Enable Convesrion effect in Transaction?" — popup shown whenever the row's Unit is
    // changed away from the product's own default Unit. pendingUnitChange holds
    // the in-progress selection (unit id/name) until the user confirms or
    // cancels; previousUnitId lets Cancel revert the <select> back to whatever
    // it was before this change, so a cancelled popup never leaves the row
    // half-changed.
    const [conversionQtyDialogOpen, setConversionQtyDialogOpen] = useState(false);
    const [conversionQtyInput, setConversionQtyInput] = useState('');
    const [pendingUnitChange, setPendingUnitChange] = useState(null); // { UnitId, unit, previousUnitId }

    const [isInitialized, setIsInitialized] = useState(false);

    // Track if component has finished initializing
    const hasInitializedRef = useRef(false);

    // When true, the next run of the live-calculation effect is skipped —
    // set right before a row's DB values are loaded into `current` (editRow),
    // so entering edit mode doesn't immediately overwrite the stored amount.
    const skipNextCalcRef = useRef(false);

    // Ref to the Product Code field for auto-focus
    const productCodeRef = useRef(null);

    // Notify parent when rows change â€” but ONLY after initialization is done
    useEffect(() => {
        if (!hasInitializedRef.current) return;
        if (onRowsChange) {
            onRowsChange(rows);
        }
    }, [rows]);

    // Reset isInitialized when coming back with data but rows are empty
    useEffect(() => {
        if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
            setIsInitialized(false);
        }
    }, [initialData?.tableData]);

    // For add mode â€” no initialData, so mark as initialized immediately
    useEffect(() => {
        if (!initialData?.tableData?.length) {
            hasInitializedRef.current = true;
        }
    }, []);



    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })
    const [discError, setDiscError] = useState("");
    const [adjustAdvancePayment, setAdjustAdvancePayment] = useState(0);
    const [adjustAmt, setAdjustAmt] = useState(0);
    const [isRecordFromReference, setIsRecordFromReference] = useState(false);
    const [advancePaymentMessage, setAdvancePaymentMessage] = useState('');
    const [advancePaymentLoading, setAdvancePaymentLoading] = useState(false);

    const [serBatchModalOpen, setSerBatchModalOpen] = useState(false);
    const [trackingType, setTrackingType] = useState(null);
    const [isRCMApplied, setIsRCMApplied] = useState(false);
    const [rcmConfirmOpen, setRcmConfirmOpen] = useState(false);
    const [rcmError, setRcmError] = useState("");


    console.log("gsts", gsts)


    const [trackingConfig, setTrackingConfig] = useState({
        applyBatchNo: 0,
        applySerialNo: 0,
        expiryDays: 0,
        warrantyMonths: 0
    });


    const [advanceReceipts, setAdvanceReceipts] = useState([]);
    const [showAdvanceCheckbox, setShowAdvanceCheckbox] = useState(false);
    const [adjustAdvance, setAdjustAdvance] = useState(false);
    const [advanceDialogOpen, setAdvanceDialogOpen] = useState(false);
    const [selectedAdvanceRows, setSelectedAdvanceRows] = useState([]);
    const [confirmAdvanceResetOpen, setConfirmAdvanceResetOpen] = useState(false);
    const [initialAdvanceRows, setInitialAdvanceRows] = useState([]);
    const advanceManuallySet = useRef(initialData?.advanceUnchecked === true);


    const [tcsEnabled, setTcsEnabled] = useState(false);
    const [tcsPercent, setTcsPercent] = useState(0);
    const [tcsAmount, setTcsAmount] = useState(0);
    const [tcsDisabled, setTcsDisabled] = useState(false);

    // "Apply TDS?" — mirrors the TCS checkbox/%/amount pattern above, shown
    // just below TCS in the totals summary when the configure is enabled.
    const [tdsEnabled, setTdsEnabled] = useState(false);
    const [tdsPercent, setTdsPercent] = useState(0);
    const [tdsAmount, setTdsAmount] = useState(0);

    const [rcmOpen, setRcmOpen] = useState(false);

    const [rcmData, setRcmData] = useState({
        taxType: '',
        taxPercent: 0,
        taxableAmt: 0,

        cgst: 0,
        sgst: 0,
        igst: 0,

        cgstAmt: 0,
        sgstAmt: 0,
        igstAmt: 0,

        utgst: 0,
        utgstAmt: 0,

        cess: 0,
        cessAmt: 0
    });






    console.log("RCMData", rcmData)

    //get advance receipt
    useEffect(() => {


        console.log("mode", mode)


        // âŒ skip in edit mode having advance enteries
        if (
            mode === "edit" &&
            initialData?.advanceReceipts?.length > 0
        ) {
            return;
        }

        const fetchAdvanceReceipts = async () => {

            if (!clientData?.clientId || !companyId) {
                setAdvanceReceipts([]);
                setShowAdvanceCheckbox(false);
                return;
            }

            try {

                const res = await axios.get(
                    `${connectionString}/api/get-advance-payReceipt`,
                    {
                        params: {
                            companyId,
                            partyId: clientData.clientId,
                            type: "payment"
                        }
                    }
                );

                if (res.data?.success) {

                    const data = res.data.data || [];

                    // setAdvanceReceipts(data);
                    setAdvanceReceipts(
                        data.map(item => ({
                            ...item,
                            AdjustAmount: item.DisplayAdvanceAmount
                        }))
                    );

                    // show checkbox only if advance exists
                    setShowAdvanceCheckbox(prev => prev || data.length > 0);

                }

            } catch (error) {

                console.error("Error fetching advance receipts", error);

                setAdvanceReceipts([]);
                setShowAdvanceCheckbox(false);
            }
        };

        fetchAdvanceReceipts();

    }, [clientData?.clientId, companyId, mode, adjustAdvance]);


    // ================= EDIT MODE ADVANCE RECEIPTS =================

    useEffect(() => {

        if (mode !== "edit") return;

        const existingAdvance =
            initialData?.advanceReceipts || [];

        // save original rows once
        setInitialAdvanceRows(existingAdvance);

        // user already unchecked previously
        if (initialData?.advanceUnchecked) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(false);

            setSelectedAdvanceRows([]);

            return;
        }

        if (existingAdvance.length > 0) {

            setShowAdvanceCheckbox(true);

            setAdvanceReceipts(existingAdvance);

            setSelectedAdvanceRows(
                existingAdvance.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            setAdjustAdvance(true);
        }

    }, [initialData, mode]);


    const handleAdjustAdvanceChange = (e) => {

        const checked = e.target.checked;

        advanceManuallySet.current = true;

        // CHECKED AGAIN
        if (checked) {

            setAdjustAdvance(true);

            // restore original edit rows
            setAdvanceReceipts(initialAdvanceRows);

            setSelectedAdvanceRows(
                initialAdvanceRows.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            return;
        }

        // âŒ DON'T RESET DIRECTLY
        // open confirmation dialog first
        setConfirmAdvanceResetOpen(true);
    };

    const confirmAdvanceReset = () => {

        setAdjustAdvance(false);

        setAdvanceDialogOpen(false);

        setSelectedAdvanceRows([]);

        setAdvanceReceipts([]);

        setConfirmAdvanceResetOpen(false);
    };

    const cancelAdvanceReset = () => {

        setConfirmAdvanceResetOpen(false);
    };

    const totalSelectedAdvance =
        selectedAdvanceRows.reduce(
            (sum, item) =>
                sum + Number(item.AdjustAmount || 0),
            0
        );

    const availableAdvanceAmount = advanceReceipts.reduce(
        (sum, item) => sum + Number(item.DisplayAdvanceAmount || 0),
        0
    );

    const remainingAdvanceAmount =
        Number(totals.total || 0) - totalSelectedAdvance;

    const handleAdvanceSelection = (selectionModel) => {

        // keep already selected rows unchanged
        let updatedRows = selectedAdvanceRows.filter(row =>
            selectionModel.includes(row.ReceiptId)
        );

        // total already used
        let usedAmount = updatedRows.reduce(
            (sum, row) => sum + Number(row.AdjustAmount || 0),
            0
        );

        // newly selected ids only
        const newSelectedIds = selectionModel.filter(
            id => !updatedRows.some(r => r.ReceiptId === id)
        );

        newSelectedIds.forEach(id => {

            const item = advanceReceipts.find(
                r => r.ReceiptId === id
            );

            if (!item) return;

            const remaining =
                Number(totals.total || 0) - usedAmount;

            // stop if no balance left
            if (remaining <= 0) return;

            const autoAmount = Math.min(
                Number(item.DisplayAdvanceAmount || 0),
                remaining
            );

            updatedRows.push({
                ...item,
                AdjustAmount: autoAmount,
                isManual: false
            });

            usedAmount += autoAmount;
        });

        setSelectedAdvanceRows(updatedRows);
    };


    useEffect(() => {
        if (!tcsEnabled) {
            setTcsAmount(0);
            return;
        }

        const baseAmount =
            Number(totals.basic || 0) +
            Number(totals.cgst || 0) +
            Number(totals.sgst || 0) +
            Number(totals.igst || 0);

        const tcs = (baseAmount * Number(tcsPercent || 0)) / 100;

        setTcsAmount(tcs);
    }, [tcsEnabled, tcsPercent, totals]);

    //reset rcm error
    useEffect(() => {
        if (rcmError) {
            const taxable = Number(rcmData.taxableAmt || 0);

            if (taxable > 0) {
                setRcmError("");
            }
        }
    }, [rcmData.taxableAmt]);

    useEffect(() => {
        if (rcmOpen) {
            setRcmData(prev => ({
                ...prev,
                taxableAmt: Number(totals.basic) || 0
            }));
        }
    }, [totals.basic, rcmOpen]);


    console.log("trackingCOnfig", trackingConfig)

    const [modalResetKey, setModalResetKey] = useState(0);


    const isTrackingEnabled = useMemo(() => {
        if (!Array.isArray(configureData)) return false;

        return configureData.some(c => c.ApplyConfigure === 1);
    }, [configureData]);

    const existingSerials = rows
        .filter((row, i) =>
            row.Id === String(current.Id) &&          // same product
            row.configType === "serial" &&           // only serial type
            i !== editIndex                  // edit case handle
        )
        .flatMap(row => row.configData || [])      // get all entries
        .map(entry => entry.value);                // extract serial numbers

    console.log("existingSerialNumbers", existingSerials)

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const API_BASE = `${connectionString}/api`;
    const transformGSTs = data => Array.isArray(data) ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode })) : [];

    const getTaxPercent = (value) => {
        if (!value) return 0;
        const cleaned = value.replace('%', '').trim();
        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? 0 : parsed;
    };

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            const gstData = transformGSTs(data);
            setGsts(Array.isArray(gstData) ? gstData : []);
        } catch (e) {
            console.error('GST lookup failed', e);
            setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
            setGsts([]);
        }
    };

    useEffect(() => {
        Hlp_Fn_GST();
    }, []);

    const isProductLocked = useMemo(() => {
        // Debit Note hard-lock
        if (DebitNoteCreated) return true;

        // Ref mode hard-lock
        if (mode === 'ref') return true;

        // Challan-linked hard-lock
        if (!Array.isArray(initialData?.tableData)) return false;

        return initialData.tableData.some(
            r => r?.challanID != null || r?.challanDtsID != null || r?.POID != null || r?.PODtsID != null
        );
    }, [DebitNoteCreated, mode, initialData?.tableData]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } });
                setUnitOptions(unitsRes.data); // Expecting [{ UnitId: 43, unit: "NOS" }, ...]
                const [cRes, sRes] = await Promise.all([
                    axios.get(`${connectionString}/api/colormaster`),
                    axios.get(`${connectionString}/api/sizemaster`)
                ]);
                const cm = {}, sm = {};
                cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
                sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
                setColorMap(cm);
                setSizeMap(sm);
            } catch (error) {
                console.error('Error fetching product or unit data:', error);
            }
        };

        fetchData();
        loadAllProducts();
    }, []);

    const handleProductAdded = async () => {
        // Reload units when product is added
        try {
            const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
                params: { companyId }
            });
            setUnitOptions(unitsRes.data);

            // Also reload products
            await loadAllProducts();
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
    };

    useEffect(() => {
        const isFromReference = initialData?.tableData?.some(row => row.challanID || row.soId || row.POID);
        setIsRecordFromReference(isFromReference);

        if (initialData?.adjustAdvancePayment) {
            setAdjustAdvancePayment(Number(initialData.adjustAdvancePayment) || 0);
            setAdjustAmt(Number(initialData.adjustAmt) || 0);
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setState calls) on every parent re-render, not just when the
        // actual saved values change.
    }, [initialData?.tableData, initialData?.adjustAdvancePayment, initialData?.adjustAmt]);

    console.log("applyBatchNo", trackingConfig.applySerialNo, trackingConfig.applyBatchNo)

    const loadAllProducts = async () => {
        try {
            // When "Show Item List Partywise in Purchase?" is enabled, pass partyId so the
            // API joins with partywiserate and returns only items configured for this party.
            const params = { companyId, mode: 'PURC' };
            if (isShowItemListPartywiseInPurchaseEnabled && clientData?.clientId) {
                params.partyId = clientData.clientId;
                params.AppRegID = selectedCompany?.AppRegID;
            }

            const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params });
            setAllProducts(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            console.error('Error fetching products:', e);
            setAllProducts([]);
        }
    };

    useEffect(() => {
        if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !unitOptions.length || !allProducts.length) {
            return;
        }

        // The products grid (`rows`) must only ever hold normal product rows.
        // Additional Charges (TransType 200-204) and RoundOff (300) are restored
        // separately (chargeInputs / roundOff field) and re-added at submit time —
        // including them here as well would duplicate them in the outgoing payload.
        const regularRows = initialData.tableData.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        const initialRows = regularRows.map((r, index) => {
            const regularIndex = index;
            const srNoValue = regularRows.length - regularIndex;
            const qty = Number(r.dispQty ?? r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const disc = Number(r.disc) || 0;
            // Prefer the exact amount stored in the database over recomputing it —
            // recomputing here can silently diverge from what was actually saved.
            // Only fall back to qty*rate*(1-disc/100) when the DB has no stored amount.
            const storedAmt = r.TaxableAmt ?? r.amount;
            const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
            const taxableAmt = hasStoredAmt ? Number(storedAmt) : qty * rate * (1 - disc / 100);

            const product = allProducts.find(p => p.Id === r.productId || p.itemCode === r.productCode);
            let taxId = r.taxId || r.TaxId || null;
            //  GST lookup
            const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

            //  final %
            let tax = matchedGST
                ? getTaxPercent(matchedGST.value)
                : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;
            let taxAmount = taxableAmt * (tax / 100);
            let cgst = '0.00', sgst = '0.00', igst = '0.00';
            let cgstAmt = '0.00', sgstAmt = '0.00', igstAmt = '0.00';
            const matchedUnit =
                unitOptions.find(u => String(u.UnitId) === String(r.UnitId)) ||
                unitOptions.find(u => u.unit?.toLowerCase() === String(r.unit).toLowerCase()) ||
                (product ? unitOptions.find(u =>
                    String(u.UnitId) === String(product.UnitId) ||
                    u.unit?.toLowerCase() === String(product.Unit?.toLowerCase())
                ) : null);

            if (product) {
                tax = tax;
                taxId = r.taxId || r.TaxId || null;        //  backend value
                taxAmount = taxableAmt * (tax / 100);
                cgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
                sgst = state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00';
                igst = state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00';
                cgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
                sgstAmt = state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00';
                igstAmt = state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00';
            } else {
                taxAmount = taxableAmt * (tax / 100);
                cgst = Number(r.CGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
                sgst = Number(r.SGST || (state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2) : 0)).toFixed(2);
                igst = Number(r.IGST || (state?.toLowerCase() !== compState?.toLowerCase() ? tax : 0)).toFixed(2);
                cgstAmt = Number(r.CGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
                sgstAmt = Number(r.SGSTAmt || (state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2) : 0)).toFixed(2);
                igstAmt = Number(r.IGSTAmt || (state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount : 0)).toFixed(2);
            }

            return {
                ...r,
                productId: r.productId || r.Id || r.id || '',
                UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId || ''),
                unit: matchedUnit ? matchedUnit.unit : (product?.Unit || ''),
                qty,
                rate,
                disc,
                tax,
                TaxableAmt: (taxableAmt || 0).toFixed(2),
                taxAmount: Number(r.taxAmount) || (taxAmount || 0).toFixed(2),
                amount: (taxableAmt || 0).toFixed(2),
                CGST: cgst,
                SGST: sgst,
                IGST: igst,
                CGSTAmt: cgstAmt,
                SGSTAmt: sgstAmt,
                IGSTAmt: igstAmt,
                UTGST: String(r.UTGST || '0.00'),
                GSTCess: String(r.GSTCess || '0.00'),
                TaxId: taxId,
                srNo: srNoValue,
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                soId: r.soId || null,
                soDtsID: r.soDtsID || null,
                // "Enable Convesrion effect in Transaction?" — re-derive these UI-only fields from
                // the product's CURRENT registered defaults (same as handleSelect),
                // since they're never persisted and a saved row's editRow spread
                // would otherwise leave defaultUnitId unset, silently disabling the
                // Unit-change conversion prompt in edit mode. baseRate stays the
                // ORIGINAL pre-conversion (Purchase) rate: r.ConversionRate when a
                // conversion was active on this saved row, else the row's own rate.
                defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId ? String(product.UnitId) : ''),
                convUnitId: product?.ConvUnit ? String(product.ConvUnit) : '',
                productConvQty: Number(product?.ConvQty) || '',
                baseRate: r.ConversionRate != null ? Number(r.ConversionRate) : rate,
                POID: r.POID || null,
                PODtsID: r.PODtsID || null, poQty: r.poQty || null, ex4: r.ex4 || null, ex5: r.ex5 || null, exQty6: r.exQty6 || null, serialNo: r.serialNo || null, oth4: r.oth4 || null, oth5: r.oth5 || null, oth6: r.oth6 || null, oth7: r.oth7 || null, TransType: r.TransType || 100,
                PODate: r.PODate || r.ProdPODate || null };
        });
        console.log(initialRows);

        setRows(initialRows);
        setNextSrNo(initialRows.length + 1);
        setIsInitialized(true);
        hasInitializedRef.current = true; // â† for lifting rows state up
    }, [initialData?.tableData, unitOptions, allProducts, state, compState, isInitialized]);

    // Re-load products when party-wise filter config or selected client changes
    // to ensure dropdown always shows the correct filtered list based on current settings
    useEffect(() => {
        loadAllProducts();
    }, [isShowItemListPartywiseInPurchaseEnabled, clientData?.clientId]);

    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed anything.
        if (skipNextCalcRef.current) {
            skipNextCalcRef.current = false;
            return;
        }

        const qty = Number(current.qty) || 0;
        const rate = Number(current.rate) || 0;
        const disc = Number(current.disc) || 0;
        const tax = Number(current.tax) || 0;
        const amountResult = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount);
        // Oth1→Oth7 are applied on top of this base TaxableAmt, so changing an Oth
        // field (added to this effect's deps below) recomputes the final amount too.
        const { taxableAmt, amounts: othAmounts } = applyOthCharges(amountResult?.taxable ?? 0, current);
        const taxAmount = taxableAmt * (tax / 100);
        setCurrent(prev => ({
            ...prev,
            ...othAmounts,
            TaxableAmt: (taxableAmt || 0).toFixed(2),
            amount: (taxableAmt || 0).toFixed(2),
            taxAmount: (taxAmount || 0).toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00'
        }));
    }, [current.qty, current.rate, current.pkg, current.disc, current.tax, current.oth1, current.oth2, current.oth3, current.oth4, current.oth5, current.oth6, current.oth7, state, compState, isApplyPkgInAmtEnabled, calculateAmount]);

    useEffect(() => {
        const n = v => Number(v || 0);
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        let basicAmountSum = 0;
        let grossAmountSum = 0;
        let discountTotal = 0;
        let cgstTotal = 0;
        let sgstTotal = 0;
        let igstTotal = 0;

        const regularRows = rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        regularRows.forEach(r => {
            const qty = n(r.qty);
            const rate = n(r.rate);
            const gross = getAmountCalcSafe(qty, rate, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
            grossAmountSum += gross;
            const taxable = n(r.amount || r.TaxableAmt);
            // Disc% is against gross only — independent of any Oth1-7
            // adjustment baked into `taxable`, which is the final amount.
            const discAmtRow = gross * (n(r.disc) / 100);
            const taxPct = n(r.tax);

            const cgstAmtRow = (r.CGSTAmt != null && r.CGSTAmt !== '') ? n(r.CGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
            const sgstAmtRow = (r.SGSTAmt != null && r.SGSTAmt !== '') ? n(r.SGSTAmt) : (isSameState ? taxable * (taxPct / 100) / 2 : 0);
            const igstAmtRow = (r.IGSTAmt != null && r.IGSTAmt !== '') ? n(r.IGSTAmt) : (isSameState ? 0 : taxable * (taxPct / 100));

            basicAmountSum += taxable;
            discountTotal += discAmtRow;
            cgstTotal += cgstAmtRow;
            sgstTotal += sgstAmtRow;
            igstTotal += igstAmtRow;
        });

        // const totalTax = cgstTotal + sgstTotal + igstTotal;
        // const finalAmount = basicAmountSum + totalTax;

        //         const tcs = tcsEnabled
        //     ? ( (basicAmountSum + totalTax) * Number(tcsPercent || 0) ) / 100
        //     : 0;

        // const finalAmount = basicAmountSum + totalTax + tcs;

        const totalTax = cgstTotal + sgstTotal + igstTotal;

        // âœ… Step A: SubTotal
        const subTotal = basicAmountSum + totalTax;

        // âœ… Step B: TCS on (Basic + GST)
        const tcs = tcsEnabled
            ? (subTotal * Number(tcsPercent || 0)) / 100
            : 0;

        // "Apply TDS?" — TDS % (fetched read-only from TDSMaster for the selected
        // party) applied on Basic Amount only (basicAmountSum), i.e. before tax —
        // unlike TCS above which applies on subTotal (Basic + GST). Folded into
        // finalAmount before Round Off, same as TCS/charges.
        const tds = tdsEnabled
            ? (basicAmountSum * Number(tdsPercent || 0)) / 100
            : 0;
        setTdsAmount(tds);

        // Additional Charges must be folded in before Round Off so roundOff reflects them
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);

        // âœ… Step C: BEFORE ROUND OFF
        const finalAmount = subTotal + tcs + tds + chargesTotal;

        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
        const decimalPart = finalAmount - Math.floor(finalAmount);

        const roundedFinal =
            decimalPart >= 0.5
                ? Math.ceil(finalAmount)
                : Math.floor(finalAmount);

        const roundOff = Number((roundedFinal - finalAmount).toFixed(2));

        // const finalWithTCS = roundedFinal + (tcsEnabled ? Number(tcsAmount) : 0);

        setTotals({
            basic: basicAmountSum.toFixed(2),
            grossBasic: grossAmountSum.toFixed(2),
            discount: discountTotal.toFixed(2),
            cgst: cgstTotal.toFixed(2),
            sgst: sgstTotal.toFixed(2),
            igst: igstTotal.toFixed(2),
            roundOff: roundOff.toFixed(2),
            total: roundedFinal.toFixed(2)
            // total: finalWithTCS.toFixed(2)
        });
    }, [rows, state, compState, tcsEnabled, tcsPercent, tdsEnabled, tdsPercent, chargesSummary]);

    // Additional Charges: given a charge and its current popup input, compute
    // the charge amount, the tax on it (only when TaxEnabled), and the final
    // (tax-inclusive) amount — this is what "Final Amount" displays live.
    const getChargeFinalAmounts = (charge, input) => {
        const chargeAmount = Number(input?.amount) || 0;
        if (!charge.TaxEnabled) {
            return { chargeAmount, taxPercent: 0, taxAmount: 0, finalAmount: chargeAmount };
        }
        const selectedGST = gsts.find(g => String(g.Id) === String(input?.taxId));
        const taxPercent = parseFloat(selectedGST?.value) || 0;
        const taxAmount = chargeAmount * taxPercent / 100;
        return { chargeAmount, taxPercent, taxAmount, finalAmount: chargeAmount + taxAmount };
    };

    // Additional Charges: on Save, fold every charge's final amount into the
    // Total Amount shown in the summary, and its tax (if any) into CGST+SGST
    // (same state) or IGST (different state) — same split rule the totals
    // useEffect above already uses for product rows.
    const handleSaveCharges = () => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
        setChargesDialogOpen(false);
    };

    // ✅ Auto-sync chargesSummary with chargeInputs whenever charges are entered
    // This ensures charges are calculated in real-time without needing a Save button
    useEffect(() => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
    }, [chargeInputs, additionalCharges, state, compState, gsts]);

    // const finalTotal =
    //     Number(totals.total) + (tcsEnabled ? Number(tcsAmount) : 0);


    useEffect(() => {
        if (!initialData?.summary) return;

        const s = initialData.summary;

        setTcsEnabled(s.tcsApplied === 1);
        setTcsPercent(s.tcsPercent || 0);
        setTcsAmount(s.tcsAmount || 0);

        // "Apply TDS?" — restore whether TDS was applied on this saved invoice,
        // AND the exact TDS % that was saved at that time (not today's TDSMaster
        // rate, which may have since changed). fetchTdsPercent below only
        // re-fetches the live rate when the user actively re-toggles the
        // checkbox, so a loaded edit keeps showing the originally-saved %/amount
        // until the user does that.
        setTdsEnabled(Number(s.tdsAmount || 0) > 0);
        setTdsPercent(s.tdsPercent || 0);
        // Depend on the specific field read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setState calls) on every parent re-render, not just when the
        // actual saved summary changes.
    }, [initialData?.summary]);

    // Check if CategoryId 18 exists in clientmaster
    useEffect(() => {
        const checkTcsClientExists = async () => {
            if (!companyId) {
                setTcsDisabled(true);
                return;
            }

            try {
                const res = await axios.get(
                    `${connectionString}/api/check-client-category`,
                    {
                        params: {
                            companyId,
                            categoryId: 18
                        }
                    }
                );

                const exists = res.data?.success && res.data?.exists;
                setTcsDisabled(!exists);

                // If TCS client doesn't exist and TCS is enabled, disable it
                if (!exists) {
                    setTcsEnabled(false);
                    setTcsPercent(0);
                    setTcsAmount(0);
                }
            } catch (error) {
                console.error("Error checking TCS client existence:", error);
                setTcsDisabled(true);
            }
        };

        checkTcsClientExists();
    }, [companyId, connectionString]);

    // "Apply TDS?" — fetch the TDS % currently registered in TDSMaster for this
    // invoice's selected party (clientData.clientId). Read-only/auto-filled,
    // never user-typed. Extracted as a callback (not just an effect) so the
    // checkbox's onChange can call it directly when the user re-checks TDS —
    // that's the only time an edit-mode invoice should pick up today's rate;
    // otherwise it keeps showing the %/amount that was actually saved.
    const fetchTdsPercent = useCallback(async () => {
        if (!companyId || !clientData?.clientId) {
            setTdsPercent(0);
            return;
        }

        try {
            const res = await axios.get(`${connectionString}/api/TDS/Search`, {
                params: {
                    companyId,
                    PartyId: clientData.clientId,
                    mode: 'search'
                }
            });

            const rows = Array.isArray(res.data?.data) ? res.data.data : [];
            setTdsPercent(rows.length > 0 ? Number(rows[0].TDSPer) || 0 : 0);
        } catch (error) {
            console.error("Error fetching TDS percentage:", error);
            setTdsPercent(0);
        }
    }, [companyId, clientData?.clientId, connectionString]);

    // Auto-fetch only in add/comp mode (no saved TDS % exists yet to preserve).
    // In edit mode, the load-back effect above restores the saved tdsPercent
    // instead — this effect intentionally skips edit mode so it doesn't
    // overwrite that with today's live TDSMaster rate.
    useEffect(() => {
        if (mode === 'edit') return;
        fetchTdsPercent();
    }, [mode, fetchTdsPercent]);

    // Handle Advance Payment checkbox click
    const handleAdvancePaymentChange = async (e) => {
        const checked = e.target.checked;

        if (!checked) {
            // Unchecked - clear messages and amounts
            setAdjustAdvancePayment(false);
            setAdvancePaymentMessage('');
            setAdjustAmt(0);
            return;
        }

        // Checked - keep checkbox checked and fetch closing balance
        setAdjustAdvancePayment(true);

        // Check client information
        if (!clientData?.clientId || !companyId) {
            setAdvancePaymentMessage('Client information is missing');
            return;
        }

        setAdvancePaymentLoading(true);
        setAdvancePaymentMessage('');

        try {
            const res = await axios.get(
                `${connectionString}/api/get-closing-balance`,
                {
                    params: {
                        partyId: clientData.clientId,
                        companyId,
                        mode: 'PURC'
                    }
                }
            );

            if (res.data?.success) {
                const closingBal = res.data.closingBalance || 0;

                // If closingBalance > 0, advance exists (for PURC mode)
                if (closingBal > 0) {
                    // Calculate AdjustAmt: use minimum of advance and BillAmt
                    const billAmount = Number(totals.total || 0);
                    const finalAdjustAmt = closingBal < billAmount ? closingBal : billAmount;

                    setAdjustAmt(finalAdjustAmt);
                    setAdvancePaymentMessage(`Advance Available: ₹${Number(closingBal).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
                } else {
                    // closingBalance <= 0, no advance
                    setAdvancePaymentMessage('There is no Advance Payment');
                    setAdjustAmt(0);
                }
            } else {
                setAdvancePaymentMessage('Error fetching advance information');
                setAdjustAmt(0);
            }
        } catch (error) {
            console.error("Error fetching closing balance:", error);
            setAdvancePaymentMessage('Error fetching advance information');
            setAdjustAmt(0);
        } finally {
            setAdvancePaymentLoading(false);
        }
    };

    console.log("totals", totals)

    const handleChange = field => e => {
        if (field === 'UnitId') {
            const selectedUnit = unitOptions.find(u => u.UnitId === Number(e.target.value));
            const newUnitId = e.target.value;

            // "Enable Convesrion effect in Transaction?" — only intervene when the config is on
            // and the newly-picked unit differs from this product's own default
            // Unit (current.defaultUnitId, captured at select time). Changing
            // back to the default reverts immediately with no popup (see below).
            if (isApplyRateOnConversionEnabled && current.defaultUnitId && String(newUnitId) !== String(current.defaultUnitId)) {
                setPendingUnitChange({
                    UnitId: newUnitId,
                    unit: selectedUnit ? selectedUnit.unit : '',
                    previousUnitId: current.UnitId,
                });
                // Pre-fill per spec: the product's registered ConvQty only when the
                // newly-picked unit matches the product's registered ConvUnit;
                // otherwise default to 1 (no known ratio for an unrelated unit).
                const matchesConvUnit = current.convUnitId && String(newUnitId) === String(current.convUnitId);
                setConversionQtyInput(matchesConvUnit && current.productConvQty ? String(current.productConvQty) : '1');
                setConversionQtyDialogOpen(true);
                return;
            }

            // Reverting to the product's own default Unit (or config is off) —
            // behave exactly as before, and clear any previously-active conversion.
            setCurrent(prev => ({
                ...prev,
                UnitId: newUnitId,
                unit: selectedUnit ? selectedUnit.unit : '',
                ConversionQty: null,
                ConversionRate: null,
                rate: prev.defaultUnitId && String(newUnitId) === String(prev.defaultUnitId) ? prev.baseRate : prev.rate,
            }));
        } else if (field === 'qty' || field === 'rate' || field === 'pkg') {
            // Qty/Rate/Pkg shift the base amount Oth1-7 are computed from —
            // reapply them live here too, same as Disc already does via handleBaseFieldChange.
            setCurrent(prev => {
                const updated = { ...prev, [field]: e.target.value };
                return { ...updated, ...recomputeTaxable(updated) };
            });
        } else {
            setCurrent(prev => ({ ...prev, [field]: e.target.value }));
        }
    };

    // "Enable Convesrion effect in Transaction?" — Confirm applies the pending Unit change plus
    // the Conversion Qty the user entered/accepted, deriving the billed Rate from
    // this row's baseRate (the product's Purchase Rate as it stood before any
    // conversion — captured once at product-select time and preserved untouched
    // so it can always be recovered). Cancel reverts the Unit selection back to
    // whatever it was before, so a cancelled popup never leaves the row
    // half-changed.
    const handleConfirmConversionQty = () => {
        if (!pendingUnitChange) return;
        const convQty = Number(conversionQtyInput) || 0;

        if (convQty > 0) {
            const { rate: convertedRate } = calculateConversion(current.baseRate, current.qty, convQty);
            setCurrent(prev => ({
                ...prev,
                UnitId: pendingUnitChange.UnitId,
                unit: pendingUnitChange.unit,
                rate: convertedRate,
                ConversionQty: convQty,
                ConversionRate: prev.baseRate,
            }));
        } else {
            // Invalid/blank conversion qty — treat like Cancel rather than divide by zero.
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }

        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleCancelConversionQty = () => {
        if (pendingUnitChange) {
            setCurrent(prev => ({ ...prev, UnitId: pendingUnitChange.previousUnitId }));
        }
        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    // Recalculate Rate from MRP when GST (TaxId) changes, if Apply MRP in Purchase is enabled
    useEffect(() => {
        if (!isApplyMRPInPurchaseEnabled || !current.MRP || Number(current.MRP) <= 0) return;

        const matchedGST = gsts.find(g => String(g.Id) === String(current.TaxId));
        if (!matchedGST) return;

        const getTaxPercent = (value) => {
            if (!value) return 0;
            const cleaned = value.replace('%', '').trim();
            const parsed = parseFloat(cleaned);
            return isNaN(parsed) ? 0 : parsed;
        };

        const tax = getTaxPercent(matchedGST.value);
        const newRate = calculatePurchaseRateFromMRP(Number(current.MRP), tax);
        const taxableAmt = current.qty * newRate * (1 - current.disc / 100);
        const taxAmount = taxableAmt * (tax / 100);

        console.log('🔄 Purchase_Invoice: GST changed, recalculating Rate from MRP:', { MRP: current.MRP, tax, newRate });

        setCurrent(prev => ({
            ...prev,
            rate: newRate,
            tax,
            amount: (taxableAmt || 0).toFixed(2),
            taxAmount: (taxAmount || 0).toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            TaxableAmt: taxableAmt.toFixed(2)
        }));
    }, [current.TaxId, isApplyMRPInPurchaseEnabled, gsts]);

    const handleSelect = async product => {
        console.log('🔍 Product selected - Full product object:', product);
        console.log('🔍 Product.MRP:', product.MRP);

        if (product.Id !== current.Id) {
            setModalResetKey(prev => prev + 1);
        }
        const matchedUnit = unitOptions.find(opt => {
            if (product.UnitId && opt.UnitId === product.UnitId) return true;
            if (product.Unit && opt.unit?.toLowerCase() === product.Unit.toLowerCase()) return true;
            if (product.unit && opt.unit?.toLowerCase() === product.unit.toLowerCase()) return true;
            return false;
        });
        const qty = 1;
        let rate = Number(product.Rate) || 0;
        let disc = Number(product.Discount) || 0;
        let MRP = Number(product.MRP) || '';
        console.log('💰 MRP value extracted:', MRP);

        // "Show Item List Partywise in Purchase?" — when enabled, this item's
        // Rate/Disc must come strictly from partywiserate for this party, with
        // NO fallback to productmaster's purchaseRate/PurcDisc.
        if (isShowItemListPartywiseInPurchaseEnabled && clientData?.clientId) {
            const partywiseData = await getPartywiseRatePurchase(product.Id, clientData.clientId);
            if (partywiseData.found) {
                rate = partywiseData.purchaseRate !== null ? partywiseData.purchaseRate : 0;
                disc = partywiseData.disc !== null ? partywiseData.disc : 0;
                console.log('✅ Purchase_Invoice: Rate/Disc taken from partywiserate (no productmaster fallback):', rate, disc);
            }
        }

        // Fetch last purchase rate if enabled
        console.log('📦 Purchase_Invoice: Product selected, checking if last purchase rate should be fetched');
        if (isLastPurchaseRateEnabled) {
            console.log('💾 Purchase_Invoice: Fetching last purchase rate for product:', product.Id, 'party:', clientData?.clientId);
            const lastPurchaseData = await getLastPurchaseRate(product.Id, clientData?.clientId);
            if (lastPurchaseData.rate !== null) {
                rate = lastPurchaseData.rate;
                console.log('✅ Purchase_Invoice: Last purchase rate fetched:', rate);
            }
            if (lastPurchaseData.disc !== null) {
                disc = lastPurchaseData.disc;
                console.log('✅ Purchase_Invoice: Last purchase disc fetched:', disc);
            }
        }

        // "Apply Partywise/Price-listwise Disc. in Purchase?" — if the item has a
        // price-list entry, use its NewPrice as the Rate; otherwise the existing
        // productmaster-based rate above is left untouched.
        if (isApplyPartywisePriceListDiscInPurchaseEnabled) {
            const priceListData = await getPriceListRatePurchase(product.Id);
            if (priceListData.found && priceListData.newPrice !== null) {
                rate = priceListData.newPrice;
                console.log('✅ Purchase_Invoice: Rate taken from pricelistdetails:', rate);
            }

            // Disc now comes from groupwisedisc (matched by this item's ItemGrpId for
            // this party), not clientmaster. If there's no matching group-wise entry,
            // Disc is 0.00 — no fallback to clientmaster or productmaster.
            if (clientData?.clientId) {
                const groupDiscData = await getGroupWiseDiscPurchase(product.Id, clientData.clientId);
                disc = groupDiscData.found && groupDiscData.disc !== null ? groupDiscData.disc : 0;
                console.log('✅ Purchase_Invoice: Disc taken from groupwisedisc (no fallback):', disc);
            }
        }

        const tax = parseFloat(product.GST) || 0;
        const taxId = product.TaxId || null;
        // "Disc Scheme" — Disc is taken from clientmaster.Disc; Oth1/Oth2 from clientmaster.Disc1/Disc2.
        // Oth1 and Oth2 are checked independently: each is filled only if it is
        // enabled, Percentage (not Rupees) and minus (AddLess). Empty/null -> 0.
        let discSchemeOth = null;
        if (isDiscSchemeEnabled && clientData?.clientId) {
            const scheme = await getClientDiscScheme(clientData.clientId);
            disc = scheme.disc || 0;
            const oth1Qualifies = isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && Boolean(getColRow(COL.OTH1)?.AddLess);
            const oth2Qualifies = isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && Boolean(getColRow(COL.OTH2)?.AddLess);
            if (oth1Qualifies || oth2Qualifies) {
                discSchemeOth = {
                    oth1: oth1Qualifies ? String(scheme.disc1 || 0) : '',
                    oth2: oth2Qualifies ? String(scheme.disc2 || 0) : '',
                };
            }
        }

        const taxableAmt = qty * rate * (1 - disc / 100);
        const taxAmount = taxableAmt * (tax / 100);
        setCurrent({
            Id: product.Id?.toString() || '',
            productCode: product.itemCode || '',
            description: product.description || '',
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            unit: matchedUnit ? matchedUnit.unit : '',
            qty,
            rate,
            disc,
            tax,
            MRP,
            batchNo: '',
            expDate: '',
            serialNo: '',
            amount: (taxableAmt || 0).toFixed(2),
            taxAmount: (taxAmount || 0).toFixed(2),
            remark: '',
            TaxId: taxId,
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            UTGST: '0.00',
            GSTCess: '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            TaxableAmt: (taxableAmt || 0).toFixed(2),
            challanDtsID: null,
            challanID: null,
            soId: null,
            soDtsID: null,
            POID: null,
            PODtsID: null,
            refNo: '',
            refDate: '',
            refQty: '',
            type: '',
            size: '',
            color: '',
            freeQty: '',
            per: '',
            pkg: '',
            oth1: discSchemeOth ? discSchemeOth.oth1 : '',
            oth2: discSchemeOth ? discSchemeOth.oth2 : '',
            oth3: '',
            oth4: '',
            oth5: '',
            oth6: '',
            oth7: '',
            GSTOth: '0.00',
            // "Enable Convesrion effect in Transaction?" — captured from productmaster at select
            // time; no conversion is active yet on a freshly-selected row.
            // baseRate is the product's Purchase Rate (productdata/retrive with
            // mode=PURC returns productmaster.purchaseRate AS Rate).
            defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : '',
            convUnitId: product.ConvUnit ? String(product.ConvUnit) : '',
            productConvQty: Number(product.ConvQty) || '',
            baseRate: rate,
            ConversionQty: null,
            ConversionRate: null
        });
        // Reapply Oth1-7 on the fresh row so Oth1/Oth2 Amount and TaxableAmt reflect the Disc Scheme.
        if (discSchemeOth) {
            setCurrent(prev => ({ ...prev, ...recomputeTaxable(prev) }));
        }

        setTrackingConfig({
            applyBatchNo: product.ApplyBatchNo || 0,
            applySerialNo: product.ApplySerialNo || 0,
            expiryDays: product.ExpiryDays || 0,
            warrantyMonths: product.WarrantyMonths || 0
        });
        // setEditIndex(null);
        setErrors({});
    };

    console.log("rows", rows)

    const addProduct = async () => {

        // Allow updates in ref mode, but prevent adding new products
        if (isProductLocked && !(mode === 'ref' && editIndex !== null)) return;

        // In ref mode, skip adding new products (only allow updates)
        if (mode === 'ref' && editIndex == null) return;

        const errs = {};
        const messages = new Set();
        const requiredFields = ['productCode', 'description', 'UnitId', 'qty', 'rate', 'tax'];

        requiredFields.forEach(field => {
            if (!current[field] && current[field] !== 0) {
                errs[field] = 'Required';
                messages.add('All fields are required.');
            }
        });

          //GST validation
          if (!current.TaxId) {
            errs.TaxId = true;
            messages.add('Please select GST before adding product.');
        }

        // TRACKING VALIDATION
        if (
            (trackingConfig.applySerialNo === 1 || trackingConfig.applyBatchNo === 1) &&
            (!current.configData || current.configData.length === 0)
        ) {
            setErrors({
                ...errs,
                global: ["Please add Serial / Batch details"]
            });
            return;
        }

        const isTracking =
            (trackingConfig.applySerialNo === 1 ||
                trackingConfig.applyBatchNo === 1) &&
            Array.isArray(current.configData);

        if (isTracking) {
            const totalTrackingQty = current.configData.reduce(
                (sum, item) => sum + (Number(item.qty) || 0),
                0
            );

            const productQty = Number(current.qty) || 0;

            if (totalTrackingQty !== productQty) {
                setErrors({
                    ...errs,
                    global: [`Product Qty (${productQty}) must match Serial/Batch Total (${totalTrackingQty})`]
                });
                return;
            }
        }



        if (!current.qty || Number(current.qty) <= 0) {
            errs.qty = 'Must be > 0';
            messages.add('Qty must be greater than 0');
        }

        if (!current.rate || Number(current.rate) <= 0) {
            errs.rate = 'Rate must be greater than 0';
            messages.add('Rate must be greater than 0');
        }

        if (current.disc < 0) {
            errs.disc = 'Cannot be negative';
            messages.add('Discount cannot be negative');
        }

        if (current.disc > 100) {
            errs.disc = 'Cannot be more than 100';
            messages.add('Discount cannot be more than 100');
        }

        if (messages.size > 0) {
            errs.global = Array.from(messages);
            setErrors(errs);
            return;
        }

        const safeDisc =
            current.disc === '' || current.disc == null
                ? 0
                : Number(current.disc);

        const qty = Number(current.qty) || 0;
        const rate = Number(current.rate) || 0;
        // const disc = Number(current.disc) || 0;
        const disc = safeDisc || 0;
        const tax = Number(current.tax) || 0;
        const baseTaxableAmt = getAmountCalcSafe(qty, rate, current.pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
        // Oth1→Oth7 are applied on top of this base TaxableAmt before the row is committed,
        // so Add/Update Product always carries the Oth-adjusted amount, not the raw base.
        const { taxableAmt, amounts: othAmounts } = applyOthCharges(baseTaxableAmt, current);
        const taxAmount = taxableAmt * (tax / 100);

        // Stock validation check
        const lNo = L_No || null;
        console.log('ProductDetails: Calling validateStock with itemId:', current.Id, 'qty:', qty, 'L_No:', lNo);
        const stockValidation = await validateStock(current.Id, qty, lNo);
        console.log('ProductDetails: Stock validation result:', stockValidation);

        if (stockValidation.shouldShowWarning) {
            console.log('ProductDetails: Showing warning dialog');
            // Show confirmation dialog for stock warning
            const confirmed = await new Promise((resolve) => {
                setStockWarningData(stockValidation);
                setStockConfirmResolve(() => resolve);
                setStockWarningOpen(true);
            });
            if (!confirmed) {
                console.log('ProductDetails: User cancelled, not adding product');
                return;
            }
        } else {
            console.log('ProductDetails: No warning needed, proceeding with add');
        }

        const row = {
            ...current,
            ...othAmounts,
            productId: current.Id,
            configData: current.configData || [],
            configType:
                trackingConfig.applySerialNo === 1
                    ? "serial"
                    : trackingConfig.applyBatchNo === 1
                        ? "batch"
                        : null,
            applyBatchNo: trackingConfig.applyBatchNo,
            applySerialNo: trackingConfig.applySerialNo,
            warrantyMonths: current.warrantyMonths || null,
            expiryDays: current.expiryDays || null,
            qty,
            rate,
            disc,
            tax,
            remark: current.remark || '',
            TaxableAmt: taxableAmt.toFixed(2),
            taxAmount: taxAmount.toFixed(2),
            amount: taxableAmt.toFixed(2),
            CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
            IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
            CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
            IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
            UTGST: current.UTGST,
            GSTCess: current.GSTCess,
            TaxId: current.TaxId,
            srNo: editIndex != null ? rows[editIndex].srNo : nextSrNo,
            challanDtsID: editIndex != null ? rows[editIndex].challanDtsID : null,
            challanID: editIndex != null ? rows[editIndex].challanID : null,
            soId: editIndex != null ? rows[editIndex].soId : null,
            soDtsID: editIndex != null ? rows[editIndex].soDtsID : null,
            POID: editIndex != null ? (rows[editIndex].POID || null) : null,
            PODtsID: editIndex != null ? (rows[editIndex].PODtsID || null) : null,
            TransType: current.TransType || 100
        };

        const existingRowIndex = rows.findIndex(
            (r, i) => r.productCode === current.productCode && i !== editIndex
        );

        // if (existingRowIndex !== -1 && editIndex == null) {
        //     setRows(prev =>
        //         prev.map((r, i) => {
        //             if (i === existingRowIndex) {
        //                 const newQty = Number(r.qty) + qty;
        //                 const newTaxableAmt = newQty * rate * (1 - disc / 100);
        //                 const newTaxAmount = newTaxableAmt * (tax / 100);
        //                 return {
        //                     ...r,
        //                     qty: newQty,
        //                     rate,
        //                     disc,
        //                     tax,
        //                     remark: current.remark || r.remark,
        //                     TaxableAmt: newTaxableAmt.toFixed(2),
        //                     taxAmount: newTaxAmount.toFixed(2),
        //                     amount: newTaxableAmt.toFixed(2),
        //                     CGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
        //                     SGST: state?.toLowerCase() === compState?.toLowerCase() ? (tax / 2).toFixed(2) : '0.00',
        //                     IGST: state?.toLowerCase() !== compState?.toLowerCase() ? tax.toFixed(2) : '0.00',
        //                     CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (newTaxAmount / 2).toFixed(2) : '0.00',
        //                     IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? newTaxAmount.toFixed(2) : '0.00',
        //                     UTGST: current.UTGST,
        //                     GSTCess: current.GSTCess,
        //                     TaxId: current.TaxId,
        //                     challanDtsID: r.challanDtsID,
        //                     challanID: r.challanID,
        //                     soId: r.soId,
        //                     soDtsID: r.soDtsID,
        //                     POID: r.POID || null,
        //                     PODtsID: r.PODtsID,
        //                     configData: [
        //                         ...(r.configData || []),
        //                         ...(current.configData || [])
        //                     ],
        //                     configType: current.configType || null,
        //                     warrantyMonths: current.warrantyMonths || null,
        //                     expiryDays: current.expiryDays || null
        //                 };
        //             }
        //             return r;
        //         })
        //     );
        // } else {
        //     if (editIndex != null) {
        //         setRows(prev => prev.map((r, i) => (i === editIndex ? row : r)));
        //     } else {
        //         setRows(prev => [row, ...prev]);
        //         setNextSrNo(prev => prev + 1);
        //     }
        // }


        if (editIndex != null) {
            setRows(prev =>
                prev.map((r, i) =>
                    i === editIndex ? { ...row, srNo: prev[i].srNo } : r
                )
            );
        } else {
            setRows(prev => [row, ...prev]);
            setNextSrNo(prev => prev + 1);
        }

        setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, MRP: '', remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', oth4: '', oth5: '', oth6: '', oth7: '', GSTOth: '0.00', TransType: 100,
            // "Enable Convesrion effect in Transaction?" — cleared along with the rest of the
            // entry row, so the next product starts with no conversion active.
            defaultUnitId: '', convUnitId: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null });
        setErrors({});
        setEditIndex(null);

        // Focus on Product Code field after adding product (not after updating)
        if (editIndex == null) {
            setTimeout(() => {
                productCodeRef.current?.focus?.();
            }, 0);
        }
    };

    const editRow = idx => {

        // if (isProductLocked) return;

        const row = rows[idx];
        console.log("row", row)
        const matchedUnit = unitOptions.find(u => String(u.UnitId) === String(row.UnitId)) ||
            unitOptions.find(u => String(u.UnitId) === String(row.unit)) ||
            unitOptions.find(u => u.unit?.toLowerCase() === String(row.unit).toLowerCase());

        // This row's Qty/Rate/Pkg/Disc are about to be loaded into `current` from
        // the DB values — skip the next live-calculation pass so it doesn't
        // immediately overwrite the stored amount before the user edits anything.
        skipNextCalcRef.current = true;

        setCurrent({
            ...row,
            Id: row.productId,
            UnitId: matchedUnit ? String(matchedUnit.UnitId) : row.UnitId || '',
            unit: matchedUnit ? matchedUnit.unit : row.unit || '',
            CGST: String(row.CGST || '0.00'),
            SGST: String(row.SGST || '0.00'),
            IGST: String(row.IGST || '0.00'),
            CGSTAmt: String(row.CGSTAmt || '0.00'),
            SGSTAmt: String(row.SGSTAmt || '0.00'),
            IGSTAmt: String(row.IGSTAmt || '0.00'),
            UTGST: String(row.UTGST || '0.00'),
            GSTCess: String(row.GSTCess || '0.00'),
            TaxableAmt: String(row.TaxableAmt || '0.00'),
            taxAmount: String(row.taxAmount || '0.00'),
            amount: String(row.amount || '0.00'),
            TaxId: row.TaxId || null,
            challanDtsID: row.challanDtsID || null,
            challanID: row.challanID || null,
            soId: row.soId || null,
            soDtsID: row.soDtsID || null,
            POID: row.POID || null,
            PODtsID: row.PODtsID || null,
            srNo: row.srNo,
        });
        setTrackingType(row.configType);
        setTrackingConfig({
            applyBatchNo: row.applyBatchNo || 0,
            applySerialNo: row.applySerialNo || 0,
            expiryDays: row.expiryDays || 0,
            warrantyMonths: row.warrantyMonths || 0
        });
        setEditIndex(idx);

    };

    const deleteRow = idx => {

        if (isProductLocked) return;

        setRows(prev => prev.filter((_, i) => i !== idx));
        if (idx === editIndex) {
            setCurrent({ Id: '', productCode: '', description: '', UnitId: '', unit: '', qty: 1, rate: 0, disc: 0, tax: 0, remark: '', CGST: '0.00', SGST: '0.00', IGST: '0.00', UTGST: '0.00', GSTCess: '0.00', CGSTAmt: '0.00', SGSTAmt: '0.00', IGSTAmt: '0.00', TaxableAmt: '0.00', taxAmount: '', amount: '', TaxId: null, challanDtsID: null, challanID: null, soId: null, soDtsID: null, POID: null, PODtsID: null, refNo: '', refDate: '', refQty: '', type: '', size: '', color: '', freeQty: '', per: '', pkg: '', oth1: '', oth2: '', oth3: '', oth4: '', oth5: '', oth6: '', oth7: '', GSTOth: '0.00' });
            setEditIndex(null);
            setErrors({});
        }
    };

    const handleNext = () => {
        if (rows.length === 0) {
            setErrors({ global: 'Add at least one product' });
            return;
        }

        // Check that all products have rate > 0 (double safety check for ref mode)
        if (mode === 'ref') {
            const productsWithZeroRate = rows.filter(r => Number(r.rate) <= 0);
            if (productsWithZeroRate.length > 0) {
                const productCodes = productsWithZeroRate.map(r => r.productCode).join(', ');
                setErrors({ global: `Rate must be greater than 0 for product(s): ${productCodes}` });
                return;
            }
        }

        // âœ… TCS validation (GLOBAL ERROR)
        if (tcsEnabled) {
            const percent = Number(tcsPercent);

            if (!tcsPercent || percent <= 0) {
                setErrors({ global: 'TCS % is required' });
                return;
            }

            if (isNaN(percent)) {
                setErrors({ global: 'Invalid TCS %' });
                return;
            }

            if (percent > 100) {
                setErrors({ global: 'TCS % cannot exceed 100' });
                return;
            }

            // if (!/^\d+(\.\d{1,2})?$/.test(tcsPercent)) {
            //     setErrors({ global: 'TCS % allows max 2 decimal places' });
            //     return;
            // }
        }
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        const payloadRows = rows.map(r => {
            const qty = Number(r.qty) || 0;
            const rate = Number(r.rate) || 0;
            const gross = getAmountCalcSafe(qty, rate, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
            const taxable = Number(r.amount || r.TaxableAmt) || 0;
            // Disc% is against gross only — independent of any Oth1-7
            // adjustment baked into `taxable`, which is the final amount.
            const discAmt = gross * ((Number(r.disc) || 0) / 100);
            const taxPct = Number(r.tax) || 0;
            const taxAmt = Number(r.taxAmount) || (taxable * (taxPct / 100));

            const cgstAmt = (r.CGSTAmt != null && r.CGSTAmt !== '') ? Number(r.CGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const sgstAmt = (r.SGSTAmt != null && r.SGSTAmt !== '') ? Number(r.SGSTAmt) : (isSameState ? taxAmt / 2 : 0);
            const igstAmt = (r.IGSTAmt != null && r.IGSTAmt !== '') ? Number(r.IGSTAmt) : (isSameState ? 0 : taxAmt);

            return {
                ...r,
                productId: r.productId,
                productCode: r.productCode,
                description: r.description,
                unit: r.unit,
                UnitId: Number(r.UnitId) || null,
                qty,
                rate,
                // "Enable Convesrion effect in Transaction?" — ConversionQty/ConversionRate mirror
                // purcinvoicedetails' columns 1:1 (null on a normal, non-converted
                // row). stockQty is the base-unit-equivalent quantity to post to
                // stockinout's StockInQty/StockOutQty; it equals qty/ConversionQty
                // when a conversion is active on this row, otherwise the plain qty.
                ConversionQty: r.ConversionQty != null ? Number(r.ConversionQty) : null,
                ConversionRate: r.ConversionRate != null ? Number(r.ConversionRate) : null,
                stockQty: r.ConversionQty
                    ? Number(((Number(r.qty) || 0) / Number(r.ConversionQty)).toFixed(2))
                    : Number(r.qty) || 0,
                MRP: Number(r.MRP) || 0,
                disc: Number(r.disc) || 0,
                tax: taxPct,
                batchNo: r.batchNo || '',
                expDate: r.expDate || null,
                serialNo: r.serialNo || '',
                remark: r.remark || '',
                gross: Number(gross.toFixed(2)),
                amount: Number(taxable.toFixed(2)),
                DiscAmt: Number(discAmt.toFixed(2)),
                taxAmount: Number(taxAmt.toFixed(2)),
                srNo: r.srNo,
                TaxId: r.TaxId || null,
                CGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPct / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPct.toFixed(2)),
                CGSTAmt: Number(cgstAmt.toFixed(2)),
                SGSTAmt: Number(sgstAmt.toFixed(2)),
                IGSTAmt: Number(igstAmt.toFixed(2)),
                UTGST: r.UTGST || '0.00',
                GSTCess: r.GSTCess || '0.00',
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                soId: r.soId || null,
                soDtsID: r.soDtsID || null,
                POID: r.POID || null,
                PODtsID: r.PODtsID || null,
                configData: (r.configData || []).map(item => ({
                    ...item,
                    expiryDate: item.expiryDate || null
                })),

                configType: r.configType || null,
                warrantyMonths: r.warrantyMonths || null,
                expiryDays: r.expiryDays || null,
                refNo: r.refNo || null,
                refDate: r.refDate || null,
                refQty: r.refQty || null,
                type: r.type || null,
                size: r.size || null,
                color: r.color || null,
                freeQty: r.freeQty || null,
                per: r.per || null,
                pkg: r.pkg || null,
                oth1: r.oth1 || null,
                oth2: r.oth2 || null,
                oth3: r.oth3 || null,
                GSTOth: r.GSTOth || null,
                poQty: r.poQty || null,
                ex4: r.ex4 || null,
                ex5: r.ex5 || null,
                exQty6: r.exQty6 || null,
                serialNo: r.serialNo || null,
                oth4: r.oth4 || null,
                oth5: r.oth5 || null,
                oth6: r.oth6 || null,
                oth7: r.oth7 || null,
                TransType: r.TransType || 100
            };
        });

        // Additional Charges: charges saved in UserDefineColumns with ColToBeAsk=1
        // (i.e. present in `additionalCharges`, sourced from UserDefineContext) are
        // folded into the invoice payload — Adc{SrNo}Amt/Adc{SrNo}TaxId in summary
        // for all 5 fixed slots, plus one pseudo item row per SELECTED charge
        // (TransType 200-204, SrNo 20000-20004) appended to tableData.
        // When a charge's Tax is disabled, its TaxId is resolved to the taxmaster
        // row where GST = 0 (found via gsts, whose `value` doubles as the % — same
        // pattern already used elsewhere in this file, e.g. parseFloat(opt.value)).
        const zeroTaxId = gsts.find(g => parseFloat(g.value) === 0)?.Id ?? null;

        const additionalChargeSummary = {};
        const additionalChargeItems = [];
        for (let slot = 1; slot <= 5; slot++) {
            const charge = additionalCharges.find(c => Number(c.SrNo) === slot);
            if (!charge) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }
            const key = charge.TransType;
            const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
            const { taxPercent, taxAmount, finalAmount } = getChargeFinalAmounts(charge, input);
            const amount = Number(input.amount) || 0;
            const taxId = charge.TaxEnabled ? (input.taxId ?? null) : zeroTaxId;

            additionalChargeSummary[`Adc${slot}Amt`] = amount;
            additionalChargeSummary[`Adc${slot}TaxId`] = taxId;

            // The item row (purchaseinvoicedetails) is now shaped exactly like a normal
            // product row (same field set as payloadRows above) instead of a small
            // subset — CGST/SGST/IGST hold the % rate, CGSTAmt/SGSTAmt/IGSTAmt hold
            // the tax amounts, TaxableAmt holds the tax-inclusive final amount (e.g.
            // 100 + 18% tax = 118), and every other normal-row field gets a sensible
            // default/analog for a charge line (no productCode/qty/rate in the usual
            // sense, so ChargeName stands in for productCode/description, qty=1,
            // rate=amount so gross/amount line up the same way a real row's do).
            const chargeItemId = getChargeItemId('PURC', slot);
            additionalChargeItems.push({
                Id: chargeItemId,
                productId: chargeItemId,
                productCode: charge.ChargeName || '',
                description: charge.ChargeName || '',
                UnitId: null,
                unit: '',
                qty: 1,
                rate: amount,
                disc: 0,
                tax: Number(taxPercent.toFixed(2)),
                batchNo: '',
                expDate: null,
                serialNo: '',
                amount: amount,
                taxAmount: Number(taxAmount.toFixed(2)),
                remark: '',
                TaxId: taxId,
                CGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                SGST: isSameState ? Number((taxPercent / 2).toFixed(2)) : 0,
                IGST: isSameState ? 0 : Number(taxPercent.toFixed(2)),
                UTGST: '0.00',
                GSTCess: '0.00',
                GSTOth: '0.00',
                GSTEduCess: '0.00',
                GSTEducessAmt: '0.00',
                CGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                SGSTAmt: isSameState ? Number((taxAmount / 2).toFixed(2)) : 0,
                IGSTAmt: isSameState ? 0 : Number(taxAmount.toFixed(2)),
                GSTCEssAmt: '0.00',
                TaxableAmt: Number(finalAmount.toFixed(2)),
                challanDtsID: null,
                challanID: null,
                soId: null,
                soDtsID: null,
                PONo: null,
                PODate: null,
                poQty: null,
                type: null,
                size: null,
                color: null,
                freeQty: null,
                per: null,
                pkg: null,
                oth1: null,
                oth2: null,
                oth3: null,
                oth4: null,
                oth5: null,
                oth6: null,
                oth7: null,
                ex4: null,
                ex5: null,
                exQty6: null,
                serialNo: '',
                configData: [],
                _isNew: true,
                configType: null,
                applyBatchNo: 0,
                applySerialNo: 0,
                warrantyMonths: null,
                expiryDays: null,
                srNo: 19999 + slot,
                dispQty: 0,
                gross: amount,
                DiscAmt: 0,
                refNo: null,
                refDate: null,
                refQty: null,
                oth1Amt: null,
                oth2Amt: null,
                oth3Amt: null,
                oth4Amt: null,
                oth5Amt: null,
                oth6Amt: null,
                oth7Amt: null,
                // Fixed identifiers driving the backend's TransType-aware SrNo
                // override (see dispatchController.js / saleInvoiceController.js).
                SrNo: 19999 + slot,
                TransType: 199 + slot,
            });
        }

        const payload = {
            tableData: [...payloadRows, ...additionalChargeItems],
            summary: {
                basic: Number(totals.basic),
                grossBasic: Number(totals.grossBasic),
                discount: Number(totals.discount),
                cgst: Number(totals.cgst) + Number(chargesSummary.cgst || 0),
                sgst: Number(totals.sgst) + Number(chargesSummary.sgst || 0),
                igst: Number(totals.igst) + Number(chargesSummary.igst || 0),
                roundOff: Number(totals.roundOff),
                tdsPercent: tdsEnabled ? Number(tdsPercent) : 0,
                tdsAmount: tdsEnabled ? Number(tdsAmount) : 0,
                tcsApplied: tcsEnabled ? 1 : 0,
                tcsPercent: tcsEnabled ? Number(tcsPercent) : 0,
                tcsAmount: tcsEnabled ? Number(tcsAmount) : 0,
                total: Number(totals.total),
                IsRCMApplied: isRCMApplied ? 1 : 0,

                RCMCGST: Number(rcmData.cgst || 0),
                RCMCGSTAmt: Number(rcmData.cgstAmt || 0),

                RCMSGST: Number(rcmData.sgst || 0),
                RCMSGSTAmt: Number(rcmData.sgstAmt || 0),

                RCMIGST: Number(rcmData.igst || 0),
                RCMIGSTAmt: Number(rcmData.igstAmt || 0),

                RCMGSTCess: Number(rcmData.cess || 0),
                RCMGSTCEssAmt: Number(rcmData.cessAmt || 0),

                RCMGSTEduCess: 0,
                RCMGSTEducessAmt: 0,

                RCMUTGSTAmt: 0,
                adjustAdvancePayment,
                adjustAmt,
                ...additionalChargeSummary
            },
            advanceAdjustments: selectedAdvanceRows.map(item => ({

                ReceiptId: item.ReceiptId,

                ReceiptNo: item.ReceiptNumber,

                AdjustAmount: Number(item.AdjustAmount || 0),

                PartyId: item.PartyId,

                BookName: item.BookName,

                DisplayAdvanceAmount:
                    Number(item.DisplayAdvanceAmount || 0),

                ReceiptDate:
                    item.Date || item.ReceiptDate || null
            })),

            advanceUnchecked: advanceManuallySet.current && !adjustAdvance,
            chargeInputs: chargeInputs
        };

        onNext(payload);
    };






    const formatINR = val => {
        const num = Number(val) || 0;
        return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const columns = [
        { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
        {
            field: 'product', headerName: 'Product', flex: 1, sortable: false, filterable: false,
            renderCell: params => {
                const { productCode, description, unit, tax, batchNo, expDate, serialNo, remark, CGSTAmt, SGSTAmt, IGSTAmt, ChallanNumber, ChallanDate , RefDocNumber, RefDocDate, RefDocLabel } = params.row;
                const isSameState = state?.toLowerCase() === compState?.toLowerCase();
                return (
                    <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
                                onClick={e => {
                                    e.stopPropagation();
                                    editRow(params.row.index);
                                }}
                            >
                                {productCode}
                            </Typography> */}
                            <Typography
                                variant="body2"
                                fontWeight="bold"
                                component="div"
                                sx={{
                                    cursor: 'pointer',
                                    color: colors.primary.main,
                                    textDecoration: 'underline',
                                    fontSize: '0.85rem'
                                }}
                                onClick={e => {
                                    e.stopPropagation();
                                    // if (mode !== 'ref' || !isProductLocked) {
                                    editRow(params.row.index);
                                    // }
                                }}
                            >
                                {productCode}
                            </Typography>

                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                {description}
                            </Typography>
                        </Box>
                        {(isColVisible('Unit') || isColVisible('Taxcode')) && (
                            <Typography variant="caption" display="block">
                                {isColVisible('Unit') && `Unit: ${unit || 'N/A'}`}
                                {isColVisible('Unit') && isColVisible('Taxcode') && ' | '}
                                {isColVisible('Taxcode') && `GST: ${tax}%`}
                            </Typography>
                        )}
                        {(isSameState ? (isColVisible('SGST Rs.') || isColVisible('CGST Rs.')) : isColVisible('IGST Rs.')) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {isSameState
                                    ? [
                                        isColVisible('SGST Rs.') && `SGST: ₹${formatINR(SGSTAmt)}`,
                                        isColVisible('CGST Rs.') && `CGST: ₹${formatINR(CGSTAmt)}`,
                                    ].filter(Boolean).join(' + ')
                                    : `IGST: ₹${formatINR(IGSTAmt)}`}
                            </Typography>
                        )}
                        {((batchNo && isColVisible('Batch No')) || (expDate && isColVisible('Exp. Date')) || serialNo) && (
                            <Typography variant="caption" display="block">
                                {batchNo && isColVisible('Batch No') && `Batch: ${batchNo}`}
                                {expDate && isColVisible('Exp. Date') && ` | Exp: ${expDate}`}
                            </Typography>
                        )}
                        {remark && isColVisible('Remark') && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
                        {OTH_FIELDS.some(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)]) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {OTH_FIELDS
                                    .filter(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)])
                                    .map(({ field, col }) => {
                                        const rupees = isOthRupeesMode(col);
                                        const displayVal = params.row[othDisplayField(field, col)];
                                        const amt = params.row[`${field}Amt`];
                                        const sign = Boolean(getColRow(col)?.AddLess) ? '-' : '';
                                        return rupees
                                            ? `${getColLabel(col, field)}: ${sign}₹${formatINR(displayVal)}`
                                            : `${getColLabel(col, field)}: ${displayVal}%${amt ? ` (${sign}₹${formatINR(amt)})` : ''}`;
                                    })
                                    .join(' | ')}
                            </Typography>
                        )}
                        {(RefDocNumber || ChallanNumber || RefDocDate || ChallanDate) && (
                            <Typography variant="caption" display="block" color='blue'>
                                {(RefDocNumber || ChallanNumber) && `${RefDocLabel || 'ChallanNo'}: ${RefDocNumber || ChallanNumber}`}
                                {(RefDocDate || ChallanDate) && ` | Date: ${RefDocDate || ChallanDate}`}
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        { field: 'qty', headerName: 'Qty', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'rate', headerName: 'Rate', width: 100, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
        { field: 'disc', headerName: 'Disc (%)', width: 50, align: 'center', headerAlign: 'center' },
        { field: 'amount', headerName: 'Amount (₹)', width: 100, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(Number(params.row.TaxableAmt || 0))}` },
        {
            width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
            renderCell: params => (
                <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error" disabled={mode === 'ref' || isProductLocked}>
                    <DeleteIcon fontSize="small" />
                </IconButton>
            )
        }
    ];

    useEffect(() => {
        if (!initialData?.summary) return;

        const s = initialData.summary;

        const isApplied = s.IsRCMApplied === 1;

        setIsRCMApplied(isApplied);

        if (isApplied) {
            setRcmData({
                taxType: '', // not storing this in DB
                taxPercent: 0, // optional

                taxableAmt: Number(totals.basic) || 0,

                cgst: Number(s.RCMCGST || 0),
                sgst: Number(s.RCMSGST || 0),
                igst: Number(s.RCMIGST || 0),

                cgstAmt: Number(s.RCMCGSTAmt || 0),
                sgstAmt: Number(s.RCMSGSTAmt || 0),
                igstAmt: Number(s.RCMIGSTAmt || 0),

                utgst: 0,
                utgstAmt: Number(s.RCMUTGSTAmt || 0),

                cess: Number(s.RCMGSTCess || 0),
                cessAmt: Number(s.RCMGSTCEssAmt || 0)
            });
        }
    }, [initialData, totals.basic]);

    const hasClientGST = Boolean(clientData?.gstValue?.trim());

    console.log("hasClientGST", hasClientGST)

    const hasGSTAmount =
        Number(totals.cgst) > 0 ||
        Number(totals.sgst) > 0 ||
        Number(totals.igst) > 0;

    const isRCMCalculated =
        Number(rcmData.cgstAmt) > 0 ||
        Number(rcmData.sgstAmt) > 0 ||
        Number(rcmData.igstAmt) > 0;



    //persist advance receipt data
    useEffect(() => {

        // user manually unchecked previously
        if (initialData?.advanceUnchecked) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(false);

            setSelectedAdvanceRows([]);

            return;
        }

        // restore previously selected advance receipts
        if (
            initialData?.advanceAdjustments &&
            initialData.advanceAdjustments.length > 0
        ) {

            setShowAdvanceCheckbox(true);

            setAdjustAdvance(true);

            setSelectedAdvanceRows(
                initialData.advanceAdjustments.map(item => ({
                    ...item,
                    isManual: true
                }))
            );

            setAdvanceReceipts(prev => {

                // merge existing receipts with selected receipts
                const existingIds = prev.map(p => p.ReceiptId);

                const missing = initialData.advanceAdjustments.filter(
                    x => !existingIds.includes(x.ReceiptId)
                );

                return [...prev, ...missing];
            });
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setState calls) on every parent re-render, not just when the
        // actual saved values change.
    }, [initialData?.advanceUnchecked, initialData?.advanceAdjustments]);

    // Fetch online stock details when current product changes (for purchase)
    useEffect(() => {
        const fetchOnlineStock = async () => {
            if (isShowOnlineStockPurchaseEnabled && current.Id) {
                console.log('📊 Purchase_Invoice: Fetching online stock details for product:', current.Id);
                try {
                    const details = await getOnlineStockDetails(current.Id);
                    console.log('📊 Purchase_Invoice: Online stock details:', details);
                    setOnlineStockDetails({
                        closingStock: details?.closingStock ?? null,
                        maxLevel: details?.maxLevel ?? null,
                        minLevel: details?.minLevel ?? null,
                    });
                } catch (error) {
                    console.error('❌ Purchase_Invoice: Error fetching online stock details:', error);
                    setOnlineStockDetails({
                        closingStock: null,
                        maxLevel: null,
                        minLevel: null,
                    });
                }
            }
        };
        fetchOnlineStock();
    }, [current.Id, isShowOnlineStockPurchaseEnabled, getOnlineStockDetails]);

    return (
        <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
                <Box display="flex" flexDirection="column" gap={2} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 2, borderRight: isSmall ? 'none' : `1px solid ${themeColors.neutral.line}`, flex: { lg: '1 1 100%' }, }} >
                    <Box>
                        <DropdownProductCode ref={productCodeRef} id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} searchBy='code' onProductMasterClose={handleProductAdded} autoFocus={!initialData?.tableData?.length} />
                        {!!errors.productCode && (<Typography color="error" variant="caption"> {errors.productCode} </Typography>)}
                    </Box>
                    {/* <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 40 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' } }} /> */}
                    {isColVisible(COL.DESCRIPTION) && (
                        <DropdownProductCode id="description" label="Description" options={allProducts} value={current.description} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} searchBy="description" onProductMasterClose={handleProductAdded} />
                    )}
                    {(isColVisible(COL.PO_NO) || isColVisible(COL.PO_DATE) || isColVisible(COL.PO_QTY)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PO_NO) && (
                                <TextField label={getColLabel(COL.PO_NO, 'PO No')} size="small" fullWidth value={current.PONo} onChange={handleChange('PONo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_DATE) && (
                                <TextField label={getColLabel(COL.PO_DATE, 'PO Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.PODate} onChange={handleChange('PODate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_QTY) && (
                                <TextField label={getColLabel(COL.PO_QTY, 'PO Qty')} type="number" size="small" fullWidth value={current.poQty} onChange={handleChange('poQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {/* {(isColVisible('Ref.No') || isColVisible('Ref. Date') || isColVisible('Ref. Qty')) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible('Ref.No') && (
                                <TextField label="Ref. No" size="small" fullWidth value={current.refNo} onChange={handleChange('refNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Date') && (
                                <TextField label="Ref. Date" type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.refDate} onChange={handleChange('refDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Qty') && (
                                <TextField label="Ref. Qty" type="number" size="small" fullWidth value={current.refQty} onChange={handleChange('refQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )} */}
                    {(isColVisible(COL.TYPE) || isColVisible(COL.SIZE) || isColVisible(COL.COLOR)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.TYPE) && (
                                <TextField label={getColLabel(COL.TYPE, 'Type')} size="small" fullWidth value={current.type} onChange={handleChange('type')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SIZE) && (
                                <TextField label={getColLabel(COL.SIZE, 'Size')} size="small" fullWidth value={current.size} onChange={handleChange('size')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.COLOR) && (
                                <TextField label={getColLabel(COL.COLOR, 'Color')} size="small" fullWidth value={current.color} onChange={handleChange('color')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {isColVisible(COL.UNIT) && (
                        <TextField label={getColLabel(COL.UNIT, 'Unit')} select required fullWidth size='small' value={String(current.UnitId)} onChange={handleChange('UnitId')} disabled={mode === 'ref'} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} >
                            <option value=""></option>
                            {unitOptions.map(u => (
                                <option key={u.UnitId} value={u.UnitId}>
                                    {u.unit}
                                </option>
                            ))}
                        </TextField>
                        )}
                        {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
                        {isColVisible(COL.TAX_CODE) && (
                        <Dropdown
                            id="gst"
                            label="GST"
                            valueKey="Id"
                            labelKey="value"
                            value={current.TaxId ? String(current.TaxId) : ""}
                            options={gsts}
                            required
                            disabled={mode === 'ref'}
                            onChange={(opt) => {
                                if (!opt) {
                                    setCurrent(prev => ({ ...prev, tax: 0, TaxId: null }));
                                } else {
                                    const gstValue = parseFloat(opt.value) || 0;
                                    setCurrent(prev => ({ ...prev, tax: gstValue, TaxId: opt.Id }));
                                }
                            }}
                            error={!!errors.TaxId}
                        />
                        )}
                    </Box>
                    {(isColVisible(COL.BATCH_NO) || isColVisible(COL.EXP_DATE) || isColVisible(COL.SERIAL_NO)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.BATCH_NO) && (
                                <TextField label={getColLabel(COL.BATCH_NO, 'Batch No')} size="small" fullWidth value={current.batchNo} onChange={handleChange('batchNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EXP_DATE) && (
                                <TextField label={getColLabel(COL.EXP_DATE, 'Exp. Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.expDate} onChange={handleChange('expDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SERIAL_NO) && (
                                <TextField label={getColLabel(COL.SERIAL_NO, 'Serial No')} size="small" fullWidth value={current.serialNo || ''} onChange={handleChange('serialNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {isApplyMRPInPurchaseEnabled ? (
                        // When Apply MRP in Purchase is enabled: Qty, MRP, Rate, Disc in single row
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {isColVisible(COL.QTY) && (
                                <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField
                                        label={getColLabel(COL.QTY, 'Qty')}
                                        required
                                        size='small'
                                        fullWidth
                                        type="number"
                                        inputProps={{ min: 0, step: 'any' }}
                                        value={current.qty}
                                        onChange={handleChange('qty')}
                                        error={!!errors.qty}
                                        helperText={errors.qty}
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                        disabled={mode === 'ref'}
                                    />
                                </Box>
                            )}
                            {/* MRP Field - visible when Apply MRP is enabled */}
                            <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                <TextField
                                    label="MRP"
                                    size='small'
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    value={current.MRP}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        const mrpValue = Number(val) || 0;

                                        setCurrent(prev => ({
                                            ...prev,
                                            MRP: val === '' ? '' : mrpValue
                                        }));

                                        if (mrpValue > 0 && current.tax > 0) {
                                            const newRate = calculatePurchaseRateFromMRP(mrpValue, current.tax);
                                            const taxableAmt = current.qty * newRate * (1 - current.disc / 100);
                                            const taxAmount = taxableAmt * (current.tax / 100);

                                            setCurrent(prev => ({
                                                ...prev,
                                                rate: newRate,
                                                amount: taxableAmt.toFixed(2),
                                                taxAmount: taxAmount.toFixed(2),
                                                CGST: state?.toLowerCase() === compState?.toLowerCase() ? (current.tax / 2).toFixed(2) : '0.00',
                                                SGST: state?.toLowerCase() === compState?.toLowerCase() ? (current.tax / 2).toFixed(2) : '0.00',
                                                IGST: state?.toLowerCase() !== compState?.toLowerCase() ? current.tax.toFixed(2) : '0.00',
                                                CGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
                                                SGSTAmt: state?.toLowerCase() === compState?.toLowerCase() ? (taxAmount / 2).toFixed(2) : '0.00',
                                                IGSTAmt: state?.toLowerCase() !== compState?.toLowerCase() ? taxAmount.toFixed(2) : '0.00',
                                                TaxableAmt: taxableAmt.toFixed(2)
                                            }));
                                        }
                                    }}
                                    InputLabelProps={{ sx: requiredAsteriskStyle }}
                                    sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                />
                            </Box>
                            {isColVisible(COL.RATE) && (
                                <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField
                                        label={getColLabel(COL.RATE, 'Rate')}
                                        required
                                        size='small'
                                        fullWidth
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={current.rate}
                                        onChange={handleChange('rate')}
                                        disabled={true}
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                    />
                                </Box>
                            )}
                            {isColVisible(COL.DISC) && (
                                <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                    <TextField
                                        label={getColLabel(COL.DISC, 'Disc%')}
                                        size="small"
                                        fullWidth
                                        type="number"
                                        inputProps={{ min: 0, max: 100 }}
                                        value={current.disc}
                                        error={!!discError}
                                        helperText={discError}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === "") {
                                                setDiscError("");
                                                handleBaseFieldChange('disc')(e);
                                                return;
                                            }
                                            if (Number(value) > 100) {
                                                setDiscError("can't be > 100%");
                                                return;
                                            }
                                            setDiscError("");
                                            handleBaseFieldChange('disc')(e);
                                        }}
                                        InputLabelProps={{ sx: requiredAsteriskStyle }}
                                        sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                    />
                                </Box>
                            )}
                        </Box>
                    ) : (
                        // When Apply MRP is not enabled: Qty, Rate, Disc in separate columns (original layout)
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.QTY) && (
                            <TextField label={getColLabel(COL.QTY, 'Qty')} required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={mode === 'ref'} />
                            )}
                            {isColVisible(COL.RATE) && (
                            <TextField label={getColLabel(COL.RATE, 'Rate')} required size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.DISC) && (
                            <TextField label={getColLabel(COL.DISC, 'Disc%')} size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                                error={!!discError}
                                helperText={discError}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // allow empty
                                    if (value === "") {
                                        setDiscError("");
                                        handleBaseFieldChange('disc')(e);
                                        return;
                                    }

                                    // show error and prevent update
                                    if (Number(value) > 100) {
                                        setDiscError("can't be > 100%");
                                        return;
                                    }

                                    setDiscError("");
                                    handleBaseFieldChange('disc')(e);
                                }} />
                            )}
                        {isTrackingEnabled && (
                            <IconButton
                                disabled={
                                    trackingConfig.applyBatchNo !== 1
                                    &&
                                    trackingConfig.applySerialNo !== 1
                                }
                                onClick={() => {
                                    if (trackingConfig.applySerialNo === 1) {
                                        setTrackingType("serial");
                                    } else if (trackingConfig.applyBatchNo === 1) {
                                        setTrackingType("batch");
                                    }
                                    setSerBatchModalOpen(true)
                                }}
                                sx={{
                                    border: '1px solid lightgray',
                                    borderRadius: 1,
                                    height: 38,
                                    width: 37,
                                    opacity:
                                        trackingConfig.applyBatchNo !== 1 &&
                                            trackingConfig.applySerialNo !== 1
                                            ? 0.4
                                            : 1
                                }}
                            >
                                <FaCartShopping />
                            </IconButton>
                        )}
                        </Box>
                    )}
                    {(isColVisible(COL.PKG) || isColVisible(COL.FREE_QTY) || isColVisible(COL.PER)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PKG) && (
                                <TextField label={getColLabel(COL.PKG, 'Pkg')} size="small" fullWidth value={current.pkg || ''} onChange={handleChange('pkg')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.FREE_QTY) && (
                                <TextField label={getColLabel(COL.FREE_QTY, 'Free Qty')} type="number" size="small" fullWidth value={current.freeQty} onChange={handleChange('freeQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PER) && (
                                <TextField label={getColLabel(COL.PER, 'Per')} size="small" fullWidth value={current.per} onChange={handleChange('per')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH1) || isColVisible(COL.OTH2) || isColVisible(COL.OTH3)) && (
                        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1.5}>
                            {isColVisible(COL.OTH1) && (
                                <TextField label={getColLabel(COL.OTH1, 'Oth 1')} size="small" fullWidth type="number" value={current[othDisplayField('oth1', COL.OTH1)] || ''} onChange={handleOthChange('oth1', COL.OTH1)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && (
                                <TextField label={`${getColLabel(COL.OTH1, 'Oth 1')} Amount`} size="small" fullWidth disabled value={current.oth1Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && (
                                <TextField label={getColLabel(COL.OTH2, 'Oth 2')} size="small" fullWidth type="number" value={current[othDisplayField('oth2', COL.OTH2)] || ''} onChange={handleOthChange('oth2', COL.OTH2)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && (
                                <TextField label={`${getColLabel(COL.OTH2, 'Oth 2')} Amount`} size="small" fullWidth disabled value={current.oth2Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && (
                                <TextField label={getColLabel(COL.OTH3, 'Oth 3')} size="small" fullWidth type="number" value={current[othDisplayField('oth3', COL.OTH3)] || ''} onChange={handleOthChange('oth3', COL.OTH3)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && !isOthRupeesMode(COL.OTH3) && (
                                <TextField label={`${getColLabel(COL.OTH3, 'Oth 3')} Amount`} size="small" fullWidth disabled value={current.oth3Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.EX4) || isColVisible(COL.EX5) || isColVisible(COL.EX_QTY6)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.EX4) && <TextField size="small" label={getColLabel(COL.EX4, 'EX4')} value={current.ex4 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex4: e.target.value }))} />}
                            {isColVisible(COL.EX5) && <TextField size="small" label={getColLabel(COL.EX5, 'EX5')} value={current.ex5 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex5: e.target.value }))} />}
                            {isColVisible(COL.EX_QTY6) && <TextField size="small" label={getColLabel(COL.EX_QTY6, 'EXQty6')} type="number" value={current.exQty6 || ''} onChange={(e) => setCurrent(p => ({ ...p, exQty6: e.target.value }))} />}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH4) || isColVisible(COL.OTH5)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH4) && <TextField size="small" type="number" label={getColLabel(COL.OTH4, 'Oth 4')} value={current[othDisplayField('oth4', COL.OTH4)] || ''} onChange={handleOthChange('oth4', COL.OTH4)} />}
                            {isColVisible(COL.OTH4) && !isOthRupeesMode(COL.OTH4) && <TextField size="small" disabled label={`${getColLabel(COL.OTH4, 'Oth 4')} Amount`} value={current.oth4Amt || ''} />}
                            {isColVisible(COL.OTH5) && <TextField size="small" type="number" label={getColLabel(COL.OTH5, 'Oth 5')} value={current[othDisplayField('oth5', COL.OTH5)] || ''} onChange={handleOthChange('oth5', COL.OTH5)} />}
                            {isColVisible(COL.OTH5) && !isOthRupeesMode(COL.OTH5) && <TextField size="small" disabled label={`${getColLabel(COL.OTH5, 'Oth 5')} Amount`} value={current.oth5Amt || ''} />}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH6) || isColVisible(COL.OTH7)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH6) && <TextField size="small" type="number" label={getColLabel(COL.OTH6, 'Oth 6')} value={current[othDisplayField('oth6', COL.OTH6)] || ''} onChange={handleOthChange('oth6', COL.OTH6)} />}
                            {isColVisible(COL.OTH6) && !isOthRupeesMode(COL.OTH6) && <TextField size="small" disabled label={`${getColLabel(COL.OTH6, 'Oth 6')} Amount`} value={current.oth6Amt || ''} />}
                            {isColVisible(COL.OTH7) && <TextField size="small" type="number" label={getColLabel(COL.OTH7, 'Oth 7')} value={current[othDisplayField('oth7', COL.OTH7)] || ''} onChange={handleOthChange('oth7', COL.OTH7)} />}
                            {isColVisible(COL.OTH7) && !isOthRupeesMode(COL.OTH7) && <TextField size="small" disabled label={`${getColLabel(COL.OTH7, 'Oth 7')} Amount`} value={current.oth7Amt || ''} />}
                        </Box>
                    )}
                    {(isColVisible(COL.UTGST) || isColVisible(COL.GST_CESS) || isColVisible(COL.GST_OTH)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.UTGST) && (
                                <TextField label={getColLabel(COL.UTGST, 'UTGST')} size="small" fullWidth type="number" value={current.UTGST} onChange={handleChange('UTGST')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_CESS) && (
                                <TextField label={getColLabel(COL.GST_CESS, 'GST Cess')} size="small" fullWidth type="number" value={current.GSTCess} onChange={handleChange('GSTCess')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {isColVisible(COL.AMOUNT) && (
                        <TextField label={getColLabel(COL.AMOUNT, 'Amount')} fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    )}
                    {isColVisible(COL.REMARK) && (
                        <Box>
                            <TextField label={getColLabel(COL.REMARK, 'Remark')} fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} inputProps={{ maxLength: 250 }} helperText={`${(current.remark || '').length}/250 characters`} />
                        </Box>
                    )}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                        {isShowOnlineStockPurchaseEnabled && current.Id && onlineStockDetails && (onlineStockDetails.closingStock !== null || onlineStockDetails.maxLevel !== null || onlineStockDetails.minLevel !== null) && (
                            <Box display="flex" justifyContent="center" gap={2} sx={{ width: '100%', p: 1.5, backgroundColor: themeColors.neutral.surfaceMuted, border: `1px solid ${themeColors.neutral.line}`, borderRadius: 1, flexWrap: 'wrap' }}>
                                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, color: themeColors.neutral.sub, fontSize: '11px', textTransform: 'uppercase' }}>Closing Stock</Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '16px', color: (onlineStockDetails.closingStock || 0) < 0 || (onlineStockDetails.closingStock || 0) === 0 ? themeColors.error.dark : themeColors.success.dark }}>
                                        {onlineStockDetails.closingStock !== undefined && onlineStockDetails.closingStock !== null ? (onlineStockDetails.closingStock || 0).toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5} sx={{ borderLeft: `1px solid ${themeColors.neutral.line}`, pl: 2 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, color: themeColors.neutral.sub, fontSize: '11px', textTransform: 'uppercase' }}>Max Level</Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '16px', color: colors.primary.main }}>
                                        {onlineStockDetails.maxLevel !== undefined && onlineStockDetails.maxLevel !== null ? (onlineStockDetails.maxLevel || 0).toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5} sx={{ borderLeft: `1px solid ${themeColors.neutral.line}`, pl: 2 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, color: themeColors.neutral.sub, fontSize: '11px', textTransform: 'uppercase' }}>Min Level</Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '16px', color: '#f57c00' }}>
                                        {onlineStockDetails.minLevel !== undefined && onlineStockDetails.minLevel !== null ? (onlineStockDetails.minLevel || 0).toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} 
                        disabled={mode === 'ref' && editIndex === null ? true :(DebitNoteCreated || (isProductLocked && mode !== 'ref'))} >
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button>
                    </Box>
                </Box>
                <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
                    {isMobile ? (
                        <Box>
                            {rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((row, i) => (
                                <Box
                                    key={i}
                                    sx={{
                                        border: `1px solid ${themeColors.neutral.lineStrong}`,
                                        borderRadius: 2,
                                        p: 1.5,
                                        mb: 1.5,
                                    }}
                                >
                                    {/* <Typography sx={{ fontWeight: 600 }}>
                                        {row.productCode} â€” <span style={{ fontStyle: "italic", fontWeight: "normal" }}>
                                            {row.description}
                                        </span>
                                    </Typography> */}
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                minWidth: 24,
                                                height: 24,
                                                borderRadius: "6px",
                                                backgroundColor: "#eef2ff",
                                                color: "#4338ca",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "12px",
                                                fontWeight: 700
                                            }}
                                        >
                                            {row.srNo}
                                        </Box>

                                        <Box component="span">
                                            {row.productCode}
                                        </Box>

                                        <Box
                                            component="span"
                                            sx={{
                                                fontStyle: "italic",
                                                fontWeight: 400,
                                                color: "#475569"
                                            }}
                                        >
                                            â€” {row.description}
                                        </Box>
                                    </Typography>

                                    {(row.RefDocNumber || row.ChallanNumber || row.RefDocDate || row.ChallanDate) && (
                                        <Typography variant="caption" display="block" color='blue'>
                                            {(row.RefDocNumber || row.ChallanNumber) && `${row.RefDocLabel || 'ChallanNo'}: ${row.RefDocNumber || row.ChallanNumber}`}
                                            {(row.RefDocDate || row.ChallanDate) && ` | Date: ${row.RefDocDate || row.ChallanDate}`}
                                        </Typography>
                                    )}

                                    <Grid container justifyContent="space-between">
                                        <Typography>Qty:</Typography>
                                        <Typography>{row.qty}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Rate:</Typography>
                                        <Typography>₹{row.rate}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Disc:</Typography>
                                        <Typography>{row.disc}%</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Amount:</Typography>
                                        <Typography>₹{row.amount}</Typography>
                                    </Grid>

                                    {/* DELETE / EDIT BUTTONS IF NEEDED */}
                                    <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                                        <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'ref' || DebitNoteCreated || isProductLocked}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'ref' || DebitNoteCreated || isProductLocked}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <DataGrid
                            rows={rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((r, i) => ({ ...r, id: i + 1, index: i }))}
                            columns={columns}
                            getRowHeight={() => 'auto'}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooter
                            sx={{
                                mt: 5,
                                border: `1px solid ${themeColors.neutral.lineStrong}`,
                                borderRadius: 1,
                                '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: themeColors.neutral.gridHeader, color: themeColors.neutral.ink, fontWeight: 700, fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.06em' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: themeColors.neutral.surfaceAlt },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: themeColors.neutral.surface }
                            }}
                        />
                    )}
                    <Box mt={3}>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Basic Amount</Typography>
                            <Typography>₹{formatINR(totals.basic)}</Typography>
                        </Grid>
                        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                            Total Discounted Amount: ₹{formatINR(totals.discount)}
                        </Typography>
                        {additionalCharges.length > 0 && (
                            <Box mb={2}>
                                <Accordion
                                    expanded={chargesCollapsibleOpen !== false ? true : chargesCollapsibleOpen}
                                    onChange={() => setChargesCollapsibleOpen(!chargesCollapsibleOpen)}
                                    sx={{ width: '100%' }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: 0.75, minHeight: 'auto' }}>
                                        <Typography variant="subtitle2">Charges</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ py: 1, px: 1 }}>
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <colgroup>
                                                    <col style={{ width: '45%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '19%' }} />
                                                </colgroup>
                                                <thead>
                                                    <tr style={{ backgroundColor: themeColors.neutral.surfaceMuted, borderBottom: `2px solid ${themeColors.neutral.line}` }}>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Charge Name</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Amount</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: `1px solid ${themeColors.neutral.line}`, fontWeight: 600, fontSize: '12px' }}>Tax</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Final Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {additionalCharges.map(charge => {
                                                        const key = charge.TransType;
                                                        if (!chargeInputs[key]) {
                                                            updateChargeInput(key, { amount: '', taxId: charge.TaxId ?? null });
                                                        }
                                                        const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
                                                        const { finalAmount } = getChargeFinalAmounts(charge, input);

                                                        return (
                                                            <tr key={key} style={{ borderBottom: `1px solid ${themeColors.neutral.line}` }}>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px' }}>{charge.ChargeName}</Typography>
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={input.amount}
                                                                        onChange={(e) => updateChargeInput(key, { amount: e.target.value })}
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: `1px solid ${themeColors.neutral.line}`, verticalAlign: 'middle' }}>
                                                                    {charge.TaxEnabled ? (
                                                                        <Dropdown
                                                                            id={`charge-tax-${key}`}
                                                                            valueKey="Id"
                                                                            labelKey="value"
                                                                            value={input.taxId ? String(input.taxId) : ""}
                                                                            options={gsts}
                                                                            onChange={(opt) => updateChargeInput(key, { taxId: opt ? opt.Id : null })}
                                                                        />
                                                                    ) : (
                                                                        <Typography variant="caption" sx={{ color: themeColors.neutral.muted, fontSize: '12px' }}>N/A</Typography>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={finalAmount.toFixed(2)}
                                                                        disabled
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, backgroundColor: themeColors.neutral.surfaceMuted, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        )}
                        {state?.toLowerCase() === compState?.toLowerCase() ? (
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>CGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.cgst) + chargesSummary.cgst)}</Typography>
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>SGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.sgst) + chargesSummary.sgst)}</Typography>
                                </Grid>
                            </>
                        ) : (
                            totals.igst > 0 && (
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>IGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.igst) + chargesSummary.igst)}</Typography>
                                </Grid>
                            )
                        )}

                        {/* TCS ROW */}
                        <Grid container justifyContent="space-between" alignItems="center" mb={-0.5} mt={-0.5}>

                            {/* LEFT SIDE */}
                            <Grid item display="flex" alignItems="center" gap={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={tcsEnabled}
                                            onChange={(e) => setTcsEnabled(e.target.checked)}
                                            disabled={tcsDisabled}
                                        />
                                    }
                                    label="TCS"
                                />

                                {tcsEnabled && (
                                    <>
                                        <TextField
                                            label="TCS %"
                                            size="small"
                                            type="number"
                                            value={tcsPercent}
                                            onChange={(e) => {
                                                let val = e.target.value;

                                                // Allow empty (for backspace)
                                                if (val === '') {
                                                    setTcsPercent('');
                                                    return;
                                                }

                                                // Regex: numbers with max 5 decimal places
                                                const regex = /^\d*\.?\d{0,5}$/;

                                                if (!regex.test(val)) {
                                                    return; // âŒ ignore invalid input
                                                }

                                                let num = Number(val);

                                                if (num < 0) num = 0;
                                                if (num > 100) num = 100;

                                                setTcsPercent(val); // keep as string for precision
                                            }}
                                            inputProps={{ min: 0, max: 100 }}
                                            sx={{ width: 90 }}
                                        />

                                        <TextField
                                            label="Amt"
                                            size="small"
                                            value={formatINR(tcsAmount)}
                                            disabled
                                            sx={{ width: 120 }}
                                        />
                                    </>
                                )}
                            </Grid>

                            {/* RIGHT SIDE (LIKE OTHER ROWS) */}
                            <Grid item>
                                <Typography>
                                    ₹{formatINR(tcsAmount)}
                                </Typography>
                            </Grid>
                        </Grid>

                        {/* TDS ROW — "Apply TDS?" configure. % is fetched read-only from
                            TDSMaster for the selected party (see fetchTdsPercent above),
                            not user-editable. */}
                        {isApplyTDSEnabled && (
                            <Grid container justifyContent="space-between" alignItems="center" mb={-0.5} mt={-0.5}>

                                {/* LEFT SIDE */}
                                <Grid item display="flex" alignItems="center" gap={2}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={tdsEnabled}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setTdsEnabled(checked);
                                                    // Re-checking TDS (in any mode, including edit) should
                                                    // pick up today's TDSMaster rate — the one time an
                                                    // edited invoice is allowed to override the saved %.
                                                    if (checked) {
                                                        fetchTdsPercent();
                                                    }
                                                }}
                                            />
                                        }
                                        label="Apply TDS ?"
                                    />

                                    {tdsEnabled && (
                                        <>
                                            <TextField
                                                label="TDS %"
                                                size="small"
                                                type="number"
                                                value={tdsPercent}
                                                disabled
                                                sx={{ width: 90 }}
                                            />

                                            <TextField
                                                label="Amt"
                                                size="small"
                                                value={formatINR(tdsAmount)}
                                                disabled
                                                sx={{ width: 120 }}
                                            />
                                        </>
                                    )}
                                </Grid>

                                {/* RIGHT SIDE (LIKE OTHER ROWS) */}
                                <Grid item>
                                    <Typography>
                                        ₹{formatINR(tdsAmount)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}


                        {/* ROUND OFF ROW */}
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>
                                Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})
                            </Typography>
                            <Typography>₹{formatINR(totals.roundOff)}</Typography>
                        </Grid>

                        <Divider sx={{ my: 1 }} />
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>Total Amount</Typography>
                            <Typography fontWeight={600}>₹{formatINR(Number(totals.total))}</Typography>
                            {/* <Typography fontWeight={600}>₹{formatINR(finalTotal)}</Typography> */}
                        </Grid>

                        <Box mt={2} display="flex" justifyContent="space-between" alignItems="center" >

                            {/* LEFT SIDE â†’ RCM */}
                            <Box display="flex" alignItems="center" gap={2}>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isRCMApplied}
                                            onChange={(e) => {
                                                const checked = e.target.checked;

                                                if (!checked) {
                                                    //  uncheck â†’ reset
                                                    setIsRCMApplied(false);
                                                    setRcmData({
                                                        taxType: '',
                                                        taxPercent: 0,
                                                        taxableAmt: 0,
                                                        cgst: 0,
                                                        sgst: 0,
                                                        igst: 0,
                                                        cgstAmt: 0,
                                                        sgstAmt: 0,
                                                        igstAmt: 0,
                                                        utgst: 0,
                                                        utgstAmt: 0,
                                                        cess: 0,
                                                        cessAmt: 0
                                                    });
                                                    return;
                                                }

                                                // âœ… CHECK â†’ same logic as before
                                                const shouldShowWarning = hasClientGST || hasGSTAmount;

                                                if (shouldShowWarning) {
                                                    setRcmConfirmOpen(true);
                                                    // â— Keep checkbox unchecked
                                                    setIsRCMApplied(false);
                                                    return;
                                                }

                                                // âœ… No GST â†’ open modal
                                                setRcmOpen(true);
                                            }}
                                        />
                                    }
                                    label="Apply RCM"
                                />

                                {/*  RCM AMOUNT INLINE */}
                                {isRCMApplied && (
                                    <Box display="flex" gap={2}>

                                        {Number(rcmData.cgstAmt) > 0 && (
                                            <Typography variant="body2">
                                                CGST: ₹{formatINR(rcmData.cgstAmt)}
                                            </Typography>
                                        )}

                                        {Number(rcmData.sgstAmt) > 0 && (
                                            <Typography variant="body2">
                                                SGST: ₹{formatINR(rcmData.sgstAmt)}
                                            </Typography>
                                        )}

                                        {Number(rcmData.igstAmt) > 0 && (
                                            <Typography variant="body2">
                                                IGST: ₹{formatINR(rcmData.igstAmt)}
                                            </Typography>
                                        )}

                                    </Box>
                                )}
                            </Box>

                            {/* RIGHT SIDE â†’ NEXT BUTTON */}
                            <Button
                                variant="contained"
                                onClick={handleNext}
                                disabled={editIndex !== null}
                            >
                                Next
                            </Button>

                        </Box>
                    </Box>
                </Box>
            </Box>
            {!!errors.global && (
                <Typography color="error" sx={{ mt: 2 }}>
                    {errors.global}
                </Typography>
            )}
            {/* <Box mt={1} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={editIndex !== null}>
                    Next
                </Button>
            </Box> */}


            {showAdvanceCheckbox && (
                <>

                    <Box mb={1}>
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: 'green'
                            }}
                        >
                            Advance Amount : {formatINR(availableAdvanceAmount)}
                        </Typography>
                    </Box>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={adjustAdvance}
                                onChange={handleAdjustAdvanceChange}
                            />
                        }
                        label="Adjust Advance Payment"
                    />

                    {adjustAdvance && (
                        <IconButton
                            size="small"
                            color='primary'
                            onClick={() => setAdvanceDialogOpen(prev => !prev)}
                            sx={{
                                border: "1px solid #a9a8a8",
                                ml: 0.5
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    )}

                </>
            )}

            <FormControlLabel
                control={
                    <Checkbox
                        checked={adjustAdvancePayment}
                        onChange={handleAdvancePaymentChange}
                        disabled={advancePaymentLoading}
                    />
                }
                label="Advance Payment"
            />

            {adjustAdvancePayment && (
                <Box mb={2} mt={1}>
                    {advancePaymentLoading ? (
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: 'gray'
                            }}
                        >
                            Loading...
                        </Typography>
                    ) : advancePaymentMessage.includes('no Advance') ? (
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 600,
                                color: 'error.main'
                            }}
                        >
                            {advancePaymentMessage}
                        </Typography>
                    ) : advancePaymentMessage ? (
                        <>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    color: 'green',
                                    mb: 1
                                }}
                            >
                                {advancePaymentMessage}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    color: 'blue'
                                }}
                            >
                                Adjust Amount : ₹{Number(adjustAmt).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </>
                    ) : null}
                </Box>
            )}

            <Dialog
                open={advanceDialogOpen}
                onClose={() => setAdvanceDialogOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderRadius: isMobile ? 0 : 2,
                        m: isMobile ? 0 : 2,
                        // width: isMobile ? '100%' : 'auto',
                        height: isMobile ? '100dvh' : 'auto',
                        // maxHeight: isMobile ? '100dvh' : '90vh',
                        display: 'flex',
                        overflow: 'hidden'
                    }
                }}
            >

                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >

                    <Typography variant="h6">
                        Select Advance Payments
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: "primary.main",
                            fontWeight: 600
                        }}
                    >
                        Bill Total : {Number(totals.total || 0).toFixed(2)}
                    </Typography>

                </DialogTitle>

                <DialogContent  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden'
                }}>

                    {/* DESKTOP */}
                    {!isMobile && (

                        <Box sx={{ height: 400, width: '100%', mt: 1 }}>

                            <DataGrid
                                rows={advanceReceipts}
                                getRowId={(row) => row.ReceiptId}
                                checkboxSelection
                                disableRowSelectionOnClick
                                // onRowSelectionModelChange={handleAdvanceSelection}
                                rowSelectionModel={selectedAdvanceRows.map(r => r.ReceiptId)}
                                isRowSelectable={() => {

                                    // âŒ disable selection
                                    if (
                                        mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0
                                    ) {
                                        return false;
                                    }

                                    return true;
                                }}

                                onRowSelectionModelChange={
                                    (newSelection) => {

                                        if (
                                            mode === "edit" &&
                                            initialData?.advanceReceipts?.length > 0
                                        ) {
                                            return;
                                        }

                                        handleAdvanceSelection(newSelection);
                                    }
                                }

                                columns={[
                                    {
                                        field: 'ReceiptNumber',
                                        headerName: 'Receipt No',
                                        flex: 1
                                    },
                                    {
                                        field: 'ReceiptDate',
                                        headerName: 'Date',
                                        flex: 1
                                    },
                                    // {
                                    //     field: 'Amount',
                                    //     headerName: 'Amount',
                                    //     flex: 1
                                    // },
                                    {
                                        field: 'DisplayAdvanceAmount',
                                        headerName: 'Available Advance',
                                        flex: 1
                                    },
                                    {
                                        field: 'AdjustAmount',
                                        headerName: 'Adjust Amount',
                                        flex: 1,
                                        renderCell: (params) => {

                                            const row = params.row;

                                            const selected = selectedAdvanceRows.some(
                                                r => r.ReceiptId === row.ReceiptId
                                            );

                                            return (
                                                <TextField
                                                    size="small"
                                                    type="number"
                                                    disabled={!selected || (mode === "edit" &&
                                                        initialData?.advanceReceipts?.length > 0)}
                                                    fullWidth
                                                    value={
                                                        selectedAdvanceRows.find(
                                                            r => r.ReceiptId === row.ReceiptId
                                                        )?.AdjustAmount || ''
                                                    }
                                                    inputProps={{
                                                        min: 0,
                                                        max: row.DisplayAdvanceAmount
                                                    }}
                                                    onChange={(e) => {

                                                        const value = Number(e.target.value || 0);

                                                        if (value > Number(row.DisplayAdvanceAmount)) {
                                                            return;
                                                        }

                                                        setSelectedAdvanceRows(prev =>
                                                            prev.map(item =>
                                                                item.ReceiptId === row.ReceiptId
                                                                    ? {
                                                                        ...item,
                                                                        AdjustAmount: value,
                                                                        isManual: true
                                                                    }
                                                                    : item
                                                            )
                                                        );
                                                    }}
                                                />
                                            );
                                        }
                                    }
                                ]}
                            />

                        </Box>
                    )}

                    {/* MOBILE */}
                    {isMobile && (
                        <>
                            <Box display="flex" justifyContent="space-between">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                advanceReceipts.length > 0 &&
                                                selectedAdvanceRows.length ===
                                                advanceReceipts.length
                                            }
                                            indeterminate={
                                                selectedAdvanceRows.length > 0 &&
                                                selectedAdvanceRows.length < advanceReceipts.length
                                            }
                                            onChange={(e) => {

                                                if (e.target.checked) {

                                                    handleAdvanceSelection(
                                                        advanceReceipts.map(
                                                            r => r.ReceiptId
                                                        )
                                                    );

                                                } else {

                                                    setSelectedAdvanceRows([]);
                                                }
                                            }}
                                        />
                                    }
                                    label="Select All"

                                    disabled={mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0}
                                />
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    overflowY: 'auto',
                                    p: 2,
                                    pb: 10
                                }}
                            >
                                {advanceReceipts.map((receipt) => {

                                    const isSelected =
                                        selectedAdvanceRows.some(
                                            r => r.ReceiptId === receipt.ReceiptId
                                        );

                                    const selectedRow =
                                        selectedAdvanceRows.find(
                                            r => r.ReceiptId === receipt.ReceiptId
                                        );

                                    return (

                                        <Box
                                            key={receipt.ReceiptId}
                                            sx={{
                                                border: `1px solid ${themeColors.neutral.line}`,
                                                borderRadius: 2,
                                                p: 2,
                                                mb: 2
                                            }}
                                        >

                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >

                                                <Checkbox
                                                    checked={isSelected}
                                                    disabled={
                                                        (!isSelected &&
                                                            totalSelectedAdvance >=
                                                            Number(totals.total || 0)) || (mode === "edit" &&
                                                                initialData?.advanceReceipts?.length > 0)
                                                    }
                                                    onChange={(e) => {

                                                        let newSelection = [];

                                                        if (e.target.checked) {

                                                            newSelection = [
                                                                ...selectedAdvanceRows.map(
                                                                    r => r.ReceiptId
                                                                ),
                                                                receipt.ReceiptId
                                                            ];

                                                        } else {

                                                            newSelection =
                                                                selectedAdvanceRows
                                                                    .filter(
                                                                        r =>
                                                                            r.ReceiptId !==
                                                                            receipt.ReceiptId
                                                                    )
                                                                    .map(r => r.ReceiptId);
                                                        }

                                                        handleAdvanceSelection(
                                                            newSelection
                                                        );
                                                    }}
                                                />

                                                <Typography fontWeight={600}>
                                                    {receipt.ReceiptNo}
                                                </Typography>
                                            </Box>

                                            <Typography variant="body2">
                                                Date :
                                                {
                                                    receipt.Date
                                                        ? new Date(receipt.Date)
                                                            .toLocaleDateString("en-GB")
                                                        : receipt.ReceiptDate
                                                            ? new Date(receipt.ReceiptDate)
                                                                .toLocaleDateString("en-GB")
                                                            : "-"
                                                }
                                            </Typography>

                                            <Typography variant="body2">
                                                Available :
                                                {receipt.DisplayAdvanceAmount}
                                            </Typography>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                label="Adjust Amount"
                                                sx={{ mt: 1.5 }}
                                                disabled={!isSelected || (mode === "edit" &&
                                                    initialData?.advanceReceipts?.length > 0)}
                                                value={
                                                    selectedRow?.AdjustAmount || ""
                                                }
                                                onChange={(e) => {

                                                    const value =
                                                        Number(e.target.value || 0);

                                                    setSelectedAdvanceRows(prev =>
                                                        prev.map(r => {

                                                            if (
                                                                r.ReceiptId !==
                                                                receipt.ReceiptId
                                                            ) {
                                                                return r;
                                                            }

                                                            return {
                                                                ...r,
                                                                AdjustAmount: value,
                                                                isManual: true
                                                            };
                                                        })
                                                    );
                                                }}
                                            />
                                        </Box>
                                    );
                                })}
                            </Box>


                        </>
                    )}

                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                        mt={2}
                    >


                        <Box
                            display="flex"
                            flexDirection={isMobile ? "column" : "row"}
                            justifyContent="space-between"
                            alignItems="center"
                            mt={isMobile ? 0 : 2}
                            sx={{ width: "100%" }}
                        >

                            <Box>
                                <Typography
                                    fontWeight={500}
                                >
                                    Remaining : 
                                    {formatINR(
                                        Number(totals.total || 0) -
                                        totalSelectedAdvance
                                    )}
                                </Typography>
                            </Box>


                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                flexWrap="wrap"
                            >
                                <Typography fontWeight={600}>
                                    Selected Advance : 
                                    {formatINR(totalSelectedAdvance)}
                                </Typography>
                            </Box>

                            <Box display="flex" gap={1}>

                                <Button
                                    onClick={() => setAdvanceDialogOpen(false)}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    variant="contained"
                                    disabled={mode === "edit" &&
                                        initialData?.advanceReceipts?.length > 0}
                                    onClick={() => {

                                        if (totalSelectedAdvance > Number(totals.total || 0)) {

                                            setSnackbar({
                                                open: true,
                                                severity: "error",
                                                message:
                                                    "Selected advance amount cannot exceed invoice total"
                                            });

                                            return;
                                        }

                                        setAdvanceDialogOpen(false);
                                    }}
                                >
                                    Done
                                </Button>

                            </Box>

                        </Box>
                    </Box>

                </DialogContent>

            </Dialog>


            <Dialog
                open={confirmAdvanceResetOpen}
                onClose={cancelAdvanceReset}
            >
                <DialogTitle>
                    Remove Advance Adjustment?
                </DialogTitle>

                <DialogContent>

                    <Typography>
                        Unchecking this will reset all adjusted advance receipts.Are you sure you want to continue?
                    </Typography>

                    <Box
                        mt={2}
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                    >
                        <Button
                            onClick={cancelAdvanceReset}
                            variant="outlined"
                        >
                            Cancel
                        </Button>

                        <Button
                            onClick={confirmAdvanceReset}
                            color="error"
                            variant="contained"
                        >
                            Reset
                        </Button>
                    </Box>

                </DialogContent>
            </Dialog>




            {/* <SerialBatchModal
                open={serBatchModalOpen}
                onClose={() => setSerBatchModalOpen(false)}
                type={trackingType}
                warrantyMonths={trackingConfig.warrantyMonths}
                expiryDays={trackingConfig.expiryDays}
                initialData={current.configData || []}

                onSave={(res) => {
                    if (res.configType === "serial") {
                        setCurrent(prev => ({
                            ...prev,
                            configData: res.data,
                            configType: "serial",
                            warrantyMonths: trackingConfig.warrantyMonths,
                            expiryDays: null
                        }));
                    } else {
                        setCurrent(prev => ({
                            ...prev,
                            configData: res.data,
                            configType: "batch",
                            expiryDays: trackingConfig.expiryDays,
                            warrantyMonths: null
                        }));
                    }
                }}
                totalProductQty={current.qty}
                key={modalResetKey}
                existingSerials={existingSerials}
                invoiceDate={invoiceDate}
                requireExpiryValidation={true}
                itemId={current.Id}
                connectionString={connectionString}
                mode={mode}
                moduleName={"Purchase Invoice"}
                productCode={current.productCode}
                rowSrNo={current.srNo}
            /> */}


            <Dialog open={rcmOpen} onClose={() => setRcmOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>RCM Calculator</DialogTitle>

                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>

                        <TextField
                            label="Taxable Amount"
                            value={rcmData.taxableAmt}
                            fullWidth
                            size="small"
                            disabled
                        />

                        <Dropdown
                            id="rcm-gst"
                            label="Tax Type"
                            valueKey="Id"
                            labelKey="value"
                            value={rcmData.taxType ? String(rcmData.taxType) : ""}
                            options={gsts}
                            onChange={(opt) => {
                                setRcmError("");
                                if (!opt) {
                                    setRcmData(prev => ({
                                        ...prev,
                                        taxType: '',
                                        taxPercent: 0
                                    }));
                                } else {
                                    const gstPercent = Number(
                                        String(opt.value).replace(/[^\d.]/g, '')
                                    ) || 0;

                                    setRcmData(prev => ({
                                        ...prev,
                                        taxType: opt.Id,       // store TaxId
                                        taxPercent: gstPercent // store %
                                    }));
                                }
                            }}
                        />

                        {rcmError && (
                            <Typography color="error" fontSize="0.8rem">
                                {rcmError}
                            </Typography>
                        )}
                        <Box display={"flex"} justifyContent={"center"}>

                            <Button
                                variant="contained"
                                onClick={() => {
                                    const taxable = Number(rcmData.taxableAmt || 0);
                                    const rate = Number(rcmData.taxPercent || 0);

                                    // âŒ Validation
                                    if (!taxable || taxable <= 0) {
                                        setRcmError("Taxable amount must be greater than 0.");
                                        return;
                                    }

                                    if (!rate) {
                                        setRcmError("Please select a tax type.");
                                        return;
                                    }

                                    // âœ… Clear error if valid
                                    setRcmError("");

                                    //  Your existing calculation logic
                                    const taxAmount = (taxable * rate) / 100;

                                    if (state?.toLowerCase() === compState?.toLowerCase()) {
                                        const halfTax = rate / 2;
                                        const halfAmt = taxAmount / 2;

                                        setRcmData(prev => ({
                                            ...prev,
                                            cgst: halfTax.toFixed(2),
                                            sgst: halfTax.toFixed(2),
                                            igst: 0,

                                            cgstAmt: halfAmt.toFixed(2),
                                            sgstAmt: halfAmt.toFixed(2),
                                            igstAmt: 0
                                        }));
                                    } else {
                                        setRcmData(prev => ({
                                            ...prev,
                                            igst: rate.toFixed(2),
                                            cgst: 0,
                                            sgst: 0,

                                            igstAmt: taxAmount.toFixed(2),
                                            cgstAmt: 0,
                                            sgstAmt: 0
                                        }));
                                    }
                                }}
                            >
                                Apply
                            </Button>

                        </Box>
                        <Box display="flex" gap={2}>
                            <TextField label="CGST %" value={rcmData.cgst} size="small" disabled fullWidth />
                            <TextField label="CGST Amt" value={rcmData.cgstAmt} size="small" disabled fullWidth />
                        </Box>

                        <Box display="flex" gap={2}>
                            <TextField label="SGST %" value={rcmData.sgst} size="small" disabled fullWidth />
                            <TextField label="SGST Amt" value={rcmData.sgstAmt} size="small" disabled fullWidth />
                        </Box>

                        <Box display="flex" gap={2}>
                            <TextField label="IGST %" value={rcmData.igst} size="small" disabled fullWidth />
                            <TextField label="IGST Amt" value={rcmData.igstAmt} size="small" disabled fullWidth />
                        </Box>

                        <Box display="flex" gap={2}>
                            <TextField label="UTGST %" value={rcmData.utgst} size="small" disabled fullWidth />
                            <TextField label="UTGST Amt" value={rcmData.utgstAmt} size="small" disabled fullWidth />
                        </Box>

                        <Box display="flex" gap={2}>
                            <TextField label="CESS %" value={rcmData.cess} size="small" disabled fullWidth />
                            <TextField label="CESS Amt" value={rcmData.cessAmt} size="small" disabled fullWidth />
                        </Box>

                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setRcmOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        disabled={!isRCMCalculated}
                        onClick={() => {
                            setIsRCMApplied(true);
                            setRcmOpen(false);

                            setTimeout(() => {
                                setSnackbar({
                                    open: true,
                                    message: "RCM applied successfully.",
                                    severity: "success"
                                });
                            }, 200);
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={rcmConfirmOpen}
                onClose={() => setRcmConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ pb: 1 }}>
                    <Typography fontWeight={600} color="error.main">
                        RCM Not Allowed
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2}>

                        {/*  Main Message */}
                        <Typography variant="body2" color="text.secondary">
                            GST is already present for this transaction. Applying RCM is not allowed.
                        </Typography>

                        {/*  Info Box */}
                        <Box
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                backgroundColor: '#f8f9fb',
                                border: `1px solid ${themeColors.neutral.line}`
                            }}
                        >

                            {/* CLIENT INFO */}
                            {hasClientGST && (
                                <Box mb={hasGSTAmount ? 1 : 0}>
                                    <Typography variant="caption" color="text.secondary">
                                        CLIENT DETAILS
                                    </Typography>

                                    <Typography variant="body2">
                                        {clientData.companyName || '-'}
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary">
                                        GST: {clientData.gstValue || 'Not Available'}
                                    </Typography>
                                </Box>
                            )}

                            {/* GST AMOUNTS */}
                            {hasGSTAmount && (
                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        APPLIED TAX DETAILS
                                    </Typography>

                                    {Number(totals.cgst) > 0 && (
                                        <Typography variant="body2">
                                            CGST: ₹{formatINR(totals.cgst)}
                                        </Typography>
                                    )}

                                    {Number(totals.sgst) > 0 && (
                                        <Typography variant="body2">
                                            SGST: ₹{formatINR(totals.sgst)}
                                        </Typography>
                                    )}

                                    {Number(totals.igst) > 0 && (
                                        <Typography variant="body2">
                                            IGST: ₹{formatINR(totals.igst)}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            setRcmConfirmOpen(false);
                            setIsRCMApplied(false);
                            setRcmError("");

                            setRcmData({
                                taxType: '',
                                taxPercent: 0,
                                taxableAmt: 0,
                                cgst: 0,
                                sgst: 0,
                                igst: 0,
                                cgstAmt: 0,
                                sgstAmt: 0,
                                igstAmt: 0,
                                utgst: 0,
                                utgstAmt: 0,
                                cess: 0,
                                cessAmt: 0
                            });
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Stock Warning Dialog */}
            <Dialog
                open={stockWarningOpen}
                onClose={() => {
                    setStockWarningOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    ⚠️ Stock Warning
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ color: themeColors.error.dark, fontSize: '16px', lineHeight: 1.6 }}>
                        {stockWarningData?.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(false);
                        }}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(true);
                        }}
                        sx={{ bgcolor: themeColors.error.dark, '&:hover': { bgcolor: themeColors.error.darker } }}
                    >
                        Yes, Save Anyway
                    </Button>
                </DialogActions>
            </Dialog>

            {/* "Enable Convesrion effect in Transaction?" — Conversion Qty popup, shown when Unit is
                changed away from the product's default Unit. */}
            <Dialog
                open={conversionQtyDialogOpen}
                onClose={handleCancelConversionQty}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    Unit Conversion
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ fontSize: '14px', color: themeColors.neutral.sub, mb: 2 }}>
                        How many {pendingUnitChange?.unit || 'unit'} make 1 {current.unit || 'base unit'}?
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Conversion Qty"
                        size="small"
                        type="text"
                        value={conversionQtyInput}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === '' || /^\d*\.?\d{0,4}$/.test(val)) setConversionQtyInput(val);
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCancelConversionQty}
                        sx={{ color: themeColors.neutral.sub, borderColor: themeColors.neutral.line }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmConversionQty}
                        sx={{ bgcolor: colors.primary.main, '&:hover': { bgcolor: '#0d5dc7' } }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={1000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </Paper>
    );
};

export default ProductDetails;
